// ─── AFTER 10TH STREAMS ──────────────────────────────────────────────────────

export const after10thStreams = [
  {
    id: 'science-pcm-pcb',
    title: 'Science Stream',
    subtitle: 'PCM / PCB',
    icon: '🔬',
    gradient: 'from-violet-600 to-indigo-700',
    description: 'Best for future Engineers, Doctors, Researchers & Scientists.',
    subjects: ['Physics', 'Chemistry', 'Maths (PCM)', 'Biology (PCB)', 'Computer Science'],
    leads_to: 'Engineering, Medical, Pharmacy, Research',
    eligibility: '10th pass | Min 60% recommended',
    duration: '2 years (11th & 12th)',
    why_choose: [
      'Highest career earning potential',
      'Gateway to IIT, AIIMS, BITS, NIT',
      'Can switch to Commerce/Arts later',
      'Globally recognized pathways',
    ],
    careers: ['Software Engineer', 'MBBS Doctor', 'Data Scientist', 'Pharmacist', 'Civil Engineer', 'Dentist'],
  },
  {
    id: 'commerce',
    title: 'Commerce Stream',
    subtitle: 'Accounts, Business, Economics',
    icon: '📊',
    gradient: 'from-blue-600 to-cyan-600',
    description: 'Perfect for future CAs, Bankers, Entrepreneurs & Finance Experts.',
    subjects: ['Accountancy', 'Business Studies', 'Economics', 'Mathematics', 'English'],
    leads_to: 'CA, Finance, Banking, Management, Law',
    eligibility: '10th pass | Any percentage',
    duration: '2 years (11th & 12th)',
    why_choose: [
      'Clear pathway to CA/CS/CMA',
      'Entrepreneurship friendly',
      'Banking & finance boom in India',
      'Lower competition than Science',
    ],
    careers: ['Chartered Accountant', 'Investment Banker', 'CS Officer', 'Business Manager', 'Economist'],
  },
  {
    id: 'arts-humanities',
    title: 'Arts / Humanities',
    subtitle: 'History, Geography, Psychology',
    icon: '🎨',
    gradient: 'from-pink-600 to-rose-600',
    description: 'Leads to Civil Services, Law, Journalism, Design & Creative careers.',
    subjects: ['History', 'Geography', 'Political Science', 'Psychology', 'Sociology'],
    leads_to: 'IAS/IPS, Law, Journalism, Design, Teaching',
    eligibility: '10th pass | Any percentage',
    duration: '2 years (11th & 12th)',
    why_choose: [
      'Path to IAS/IPS Civil Services',
      'Law is highly lucrative now',
      'Media & creative fields booming',
      'Most diverse career options',
    ],
    careers: ['IAS/IPS Officer', 'Lawyer', 'Journalist', 'Fashion Designer', 'Psychologist'],
  },
  {
    id: 'iti',
    title: 'ITI / Vocational',
    subtitle: 'Industrial Training Institute',
    icon: '🔧',
    gradient: 'from-orange-500 to-amber-600',
    description: 'Skill-based trades for quick employment. Govt-certified courses.',
    subjects: ['Electrician', 'Fitter', 'Welder', 'Mechanic', 'Plumber', 'Carpenter'],
    leads_to: 'Govt Jobs, Private Industry, Self-Employment',
    eligibility: '10th pass | Any percentage',
    duration: '6 months – 2 years',
    why_choose: [
      'Job-ready in 6 months – 2 years',
      'Govt ITI is free or low-cost',
      'High demand in manufacturing/infrastructure',
      'Can do B.Tech later (lateral entry)',
    ],
    careers: ['Electrician', 'Auto Mechanic', 'Welder', 'Plumber', 'CNC Operator'],
  },
  {
    id: 'polytechnic',
    title: 'Polytechnic / Diploma',
    subtitle: 'Engineering Diploma',
    icon: '⚙️',
    gradient: 'from-teal-600 to-green-600',
    description: '3-year diploma. Direct entry to B.Tech 2nd year via lateral entry.',
    subjects: ['Civil', 'Mechanical', 'Electrical', 'Computer', 'Electronics'],
    leads_to: 'Junior Engineer, B.Tech Lateral Entry, Govt Jobs',
    eligibility: '10th pass | Min 50%',
    duration: '3 years',
    why_choose: [
      'Shortcut to engineering career',
      'B.Tech direct 2nd year entry',
      'Immediate job opportunities',
      'Low fees compared to B.Tech directly',
    ],
    careers: ['Junior Engineer', 'Diploma Engineer', 'Site Supervisor', 'Technical Trainer'],
  },
  {
    id: 'skill-courses',
    title: 'Skill Courses',
    subtitle: 'PMKVY, NSDC, Short-term',
    icon: '🎯',
    gradient: 'from-slate-600 to-gray-700',
    description: 'Government-certified short-term skill development courses for quick employment.',
    subjects: ['Digital Marketing', 'Beauty & Wellness', 'Retail', 'Healthcare Aide', 'Coding Basics'],
    leads_to: 'Entry-level jobs, Entrepreneurship, Self-employment',
    eligibility: '10th pass | Any percentage',
    duration: '3 months – 1 year',
    why_choose: [
      'PMKVY courses often free',
      'Quick placement assistance',
      'Entrepreneurship opportunities',
      'Upgrade skills anytime',
    ],
    careers: ['Digital Marketer', 'Beautician', 'Retail Executive', 'Healthcare Worker'],
  },
];

// ─── AFTER 12TH STREAMS ──────────────────────────────────────────────────────

export const after12thStreams = [
  {
    id: 'pcm',
    title: 'Science — PCM',
    subtitle: 'Physics, Chemistry, Maths',
    icon: '🔢',
    gradient: 'from-violet-600 to-indigo-700',
    description: 'Engineering, Technology, AI/ML, DevOps, Electronics, Circuit Design, Architecture, Defence, and Data Science.',
    careersCount: 8,
    topExams: ['JEE Main', 'JEE Advanced', 'BITSAT'],
  },
  {
    id: 'pcb',
    title: 'Science — PCB',
    subtitle: 'Physics, Chemistry, Biology',
    icon: '🧬',
    gradient: 'from-rose-600 to-pink-600',
    description: 'Medical, Dental, Pharmacy, Nursing, Veterinary, Agriculture.',
    careersCount: 7,
    topExams: ['NEET-UG', 'AIIMS', 'JIPMER'],
  },
  {
    id: 'commerce-12',
    title: 'Commerce',
    subtitle: 'Accounts, Business, Economics',
    icon: '💰',
    gradient: 'from-blue-600 to-cyan-600',
    description: 'CA, CS, CMA, Banking, Finance, Management, Entrepreneurship.',
    careersCount: 6,
    topExams: ['CA Foundation', 'IPMAT', 'DU JAT'],
  },
  {
    id: 'arts-12',
    title: 'Arts / Humanities',
    subtitle: 'History, Geography, Sociology',
    icon: '🏛️',
    gradient: 'from-amber-500 to-orange-600',
    description: 'Civil Services, Law, Journalism, Design, Hotel Management.',
    careersCount: 7,
    topExams: ['CLAT', 'UPSC', 'NIFT'],
  },
  {
    id: 'bsc',
    title: 'B.Sc — Sciences & CS',
    subtitle: 'Maths, Physics, Chemistry, Biology, Computer Science',
    icon: '🧮',
    gradient: 'from-emerald-600 to-teal-600',
    description: 'Teaching, software, nursing, agriculture, biotechnology, pharmacy, physiotherapy, forestry, microbiology, research, banking & more.',
    careersCount: 12,
    topExams: ['CUET', 'NEET', 'ICAR AIEEA', 'IIT JAM', 'GPAT', 'NABARD', 'NCLEX-RN'],
  },
];

// ─── FULL CAREER ROADMAPS ─────────────────────────────────────────────────────

export const careerRoadmaps = {
  // ── PCM CAREERS ─────────────────────────────────────────────────────────────
  pcm: [
    {
      id: 'software-engineer',
      title: 'Software Engineer',
      tagline: 'Build apps, platforms & the digital world',
      icon: '💻',
      gradient: 'from-violet-600 to-indigo-700',
      bgLight: 'bg-violet-50',
      textColor: 'text-violet-700',
      demand: 'Extremely High',
      avgSalary: '₹4L – ₹50L/year',
      globalSalary: '$80K – $200K/year',
      duration: '4 years (B.Tech)',
      programmingLanguages: ['Python', 'Java', 'JavaScript', 'C++'],
      mustKnow: ['DSA basics', 'Git & GitHub', 'Databases and SQL', 'Linux basics'],
      topRecruiters: ['Google', 'Microsoft', 'Amazon', 'Infosys', 'TCS', 'Wipro', 'Flipkart', 'Zomato'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Focus on Maths & Science — aim 80%+', 'Start exploring logic puzzles & basic computers', 'Practice mental maths, reasoning'],
          tip: 'Optional: Learn Scratch or Python basics online (free on YouTube)',
        },
        {
          step: 2, title: '11th–12th PCM', icon: '🔬',
          duration: '2 years', type: 'education',
          details: ['Take Physics, Chemistry, Maths', 'Add Computer Science as optional subject', 'Begin JEE Foundation coaching'],
          tip: 'Score 75%+ in 12th (required for JEE Advanced)',
        },
        {
          step: 3, title: 'JEE Main / State CET', icon: '📝',
          duration: 'Exam in Jan & Apr', type: 'exam',
          details: ['JEE Main: Qualifying exam for NITs, IIITs, CFTIs', 'Also apply: BITSAT, MHT-CET, KCET, VITEEE', 'Top rank → JEE Advanced (for IITs)'],
          tip: 'Even a moderate JEE rank gets you NIT/good private college',
        },
        {
          step: 4, title: 'B.Tech Computer Science', icon: '🎓',
          duration: '4 years', type: 'education',
          details: ['Study DSA, Algorithms, DBMS, OS, Networks', 'Do 2–3 internships from 2nd year', 'Build projects, contribute to GitHub', 'Join coding clubs & hackathons'],
          tip: 'Focus on Data Structures & Algorithms — key for placements',
        },
        {
          step: 5, title: 'Internship / Training', icon: '🏢',
          duration: '6 months – 1 year', type: 'training',
          details: ['Apply on LinkedIn, Internshala, AngelList', 'Summer internships at product companies', 'Open source contributions add value'],
          tip: 'A paid internship at a product company can fetch ₹50K–₹2L/month',
        },
        {
          step: 6, title: 'Campus Placement / Job Hunt', icon: '💼',
          duration: '3–6 months', type: 'milestone',
          details: ['Target FAANG, top Indian startups, MNCs', 'Prepare: Leetcode, System Design, CS fundamentals', 'Fresher packages: ₹4L – ₹50L depending on company'],
          tip: 'IIT/NIT top coders get ₹40L–₹1Cr packages from global companies',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: ['Junior → Senior → Lead → Architect → CTO', 'Switch to product companies for better pay', 'Option: Start your own startup'],
          tip: 'Stay updated — the tech world evolves fast',
        },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'NIT/IIIT/CFTI admissions' },
        { name: 'JEE Advanced', month: 'May', desc: 'IIT admissions (top 2.5L JEE Main qualifiers)' },
        { name: 'BITSAT', month: 'May–Jun', desc: 'BITS Pilani/Goa/Hyderabad' },
        { name: 'VITEEE', month: 'April', desc: 'VIT University' },
        { name: 'MHT-CET', month: 'May', desc: 'Maharashtra state engineering' },
        { name: 'SRMJEE', month: 'April', desc: 'SRM Institute' },
      ],
      topColleges: ['IIT Bombay', 'IIT Delhi', 'IIT Madras', 'NIT Trichy', 'BITS Pilani', 'IIIT Hyderabad', 'VIT Vellore', 'DTU Delhi'],
      careerGrowth: [
        { level: 'Fresher (0–2 yrs)', role: 'Junior Software Engineer / SDE-1', salary: '₹4L – ₹15L' },
        { level: 'Mid Level (3–5 yrs)', role: 'Software Engineer / SDE-2', salary: '₹12L – ₹30L' },
        { level: 'Senior (6–9 yrs)', role: 'Senior Engineer / Tech Lead', salary: '₹25L – ₹60L' },
        { level: 'Leadership (10+ yrs)', role: 'Principal Engineer / CTO', salary: '₹60L – ₹2Cr+' },
      ],
    },
    {
      id: 'data-scientist',
      title: 'Data Scientist / AI Engineer',
      tagline: 'Turn data into intelligence & decisions',
      icon: '🤖',
      gradient: 'from-indigo-600 to-blue-700',
      bgLight: 'bg-indigo-50',
      textColor: 'text-indigo-700',
      demand: 'Extremely High',
      avgSalary: '₹6L – ₹60L/year',
      globalSalary: '$100K – $300K/year',
      duration: '4 years (B.Tech) + optional M.Tech/MS',
      programmingLanguages: ['Python', 'SQL', 'R'],
      mustKnow: ['Statistics', 'Pandas / NumPy', 'Machine Learning basics', 'Data visualization'],
      topRecruiters: ['Google DeepMind', 'Amazon', 'Meta AI', 'Microsoft', 'Razorpay', 'CRED', 'Meesho'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Excel in Maths & Statistics', 'Learn Excel / Google Sheets', 'Develop analytical thinking'], tip: 'Strong maths foundation is critical for Data Science' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Focus on Maths, Statistics concepts', 'Start Python basics (free courses)', 'Learn probability & permutations well'], tip: 'Statistics knowledge from 11th-12th is directly used in Data Science' },
        { step: 3, title: 'JEE Main / State CET', icon: '📝', duration: 'Jan & Apr', type: 'exam', details: ['Clear JEE for B.Tech CS/Data Science', 'Alternatively: B.Sc Statistics at top college', 'New: B.Tech AI & Data Science courses available'], tip: 'IITs now offer dedicated B.Tech in AI & Data Science' },
        { step: 4, title: 'B.Tech CS / Data Science', icon: '🎓', duration: '4 years', type: 'education', details: ['Study ML, Deep Learning, Statistics, Probability', 'Learn Python, R, SQL, TensorFlow, PyTorch', 'Do research projects, publish papers', 'Kaggle competitions for practical exposure'], tip: 'Kaggle competitions are seen like coding contests by top companies' },
        { step: 5, title: 'Specialization / MS', icon: '🔬', duration: '2 years (optional)', type: 'education', details: ['M.Tech in AI/ML from IIT/NIT', 'MS from USA/Canada/Germany', 'Online: Andrew Ng courses, fast.ai'], tip: 'MS abroad significantly boosts salary to $100K+ from day one' },
        { step: 6, title: 'Data Science Job', icon: '💼', duration: 'Ongoing', type: 'milestone', details: ['Roles: Data Analyst → Data Scientist → ML Engineer → AI Researcher', 'Industries: Finance, Healthcare, E-commerce, Govt'], tip: 'Build a portfolio on GitHub with end-to-end projects' },
        { step: 7, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Lead Data Scientist → Principal → Chief AI Officer', 'Option: Research at ISRO, DRDO, CSIR, academic institutions'], tip: 'AI is the fastest growing field globally — huge opportunities ahead' },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'B.Tech CS/AI at NITs, IIITs' },
        { name: 'JEE Advanced', month: 'May', desc: 'IIT B.Tech in AI & Data Science' },
        { name: 'BITSAT', month: 'May–Jun', desc: 'BITS Pilani' },
        { name: 'CUET', month: 'May', desc: 'B.Sc Statistics/Maths at DU' },
      ],
      topColleges: ['IIT Bombay (AI)', 'IIT Hyderabad (AI)', 'BITS Pilani', 'NIT Trichy', 'ISI Kolkata', 'CMI Chennai', 'IIIT Hyderabad', 'DTU Delhi'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Data Analyst / Junior Data Scientist', salary: '₹4L – ₹12L' },
        { level: 'Mid (3–5 yrs)', role: 'Data Scientist / ML Engineer', salary: '₹12L – ₹35L' },
        { level: 'Senior (6–9 yrs)', role: 'Senior DS / AI Research Scientist', salary: '₹30L – ₹80L' },
        { level: 'Lead (10+ yrs)', role: 'Chief AI Officer / Director of AI', salary: '₹70L – ₹3Cr+' },
      ],
    },
    {
      id: 'ai-ml-engineer',
      title: 'AI / ML Engineer',
      tagline: 'Build models, recommendations, and intelligent products',
      icon: '🤖',
      gradient: 'from-indigo-600 to-violet-700',
      bgLight: 'bg-indigo-50',
      textColor: 'text-indigo-700',
      demand: 'Extremely High',
      avgSalary: '₹6L – ₹60L/year',
      globalSalary: '$110K – $300K/year',
      duration: '4 years (B.Tech) + optional MS',
      programmingLanguages: ['Python', 'SQL', 'C++'],
      mustKnow: ['Maths & statistics', 'PyTorch / TensorFlow', 'NLP & computer vision basics', 'Project building'],
      topRecruiters: ['Google', 'Microsoft', 'Amazon', 'OpenAI', 'Meta', 'NVIDIA', 'Adobe', 'Indian startups'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Build strong Maths and logical thinking', 'Start basic coding curiosity with Python or Scratch', 'Learn to solve puzzles and analyze patterns'], tip: 'AI/ML starts with strong problem solving, not just coding' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Choose PCM with focus on Maths', 'Learn Python, basic statistics and Excel', 'Practice probability, matrices, and graphs'], tip: 'Maths + statistics are the foundation of machine learning' },
        { step: 3, title: 'JEE Main / State CET', icon: '📝', duration: 'Jan & Apr', type: 'exam', details: ['Target B.Tech CSE, AI/DS, or IT branches', 'Also apply for B.Sc AI / Statistics options', 'Use JEE, BITSAT, VITEEE, MHT-CET wisely'], tip: 'A good CS/AI college makes your portfolio growth much faster' },
        { step: 4, title: 'B.Tech in CS / AI / DS', icon: '🎓', duration: '4 years', type: 'education', details: ['Study ML, Deep Learning, NLP, Computer Vision', 'Learn Python, PyTorch, TensorFlow, SQL, Git', 'Build projects, internships, and Kaggle experience'], tip: 'Showcase projects on GitHub and a clean portfolio website' },
        { step: 5, title: 'Internships & Projects', icon: '💼', duration: '6 months – 1 year', type: 'training', details: ['Work on AI chatbots, recommendation systems, vision apps', 'Join hackathons and open-source communities', 'Try research internships if you like academics'], tip: 'Hands-on projects matter more than just certificates' },
        { step: 6, title: 'AI/ML Job', icon: '🚀', duration: 'Ongoing', type: 'milestone', details: ['Roles: AI Engineer, ML Engineer, Applied Scientist', 'Industries: tech, fintech, healthcare, retail, media', 'Possible path: research, product, or startup'], tip: 'Companies hire for model building, deployment, and problem solving' },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'B.Tech CSE / AI / DS at NITs, IIITs, state colleges' },
        { name: 'JEE Advanced', month: 'May', desc: 'IIT CSE / AI / Data Science' },
        { name: 'BITSAT', month: 'May–Jun', desc: 'BITS Pilani AI/CS path' },
        { name: 'VITEEE', month: 'April', desc: 'VIT CSE / AI programs' },
      ],
      topColleges: ['IIT Hyderabad', 'IIT Bombay', 'IIIT Hyderabad', 'BITS Pilani', 'NIT Trichy', 'CMI Chennai', 'ISI Kolkata', 'DTU Delhi'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Junior AI / ML Engineer', salary: '₹6L – ₹15L' },
        { level: 'Mid (3–5 yrs)', role: 'AI Engineer / Applied Scientist', salary: '₹15L – ₹35L' },
        { level: 'Senior (6–9 yrs)', role: 'Senior ML Engineer / Lead AI Engineer', salary: '₹35L – ₹80L' },
        { level: 'Lead (10+ yrs)', role: 'Principal AI Engineer / Head of AI', salary: '₹80L – ₹3Cr+' },
      ],
    },
    {
      id: 'devops-engineer',
      title: 'DevOps / Cloud Engineer',
      tagline: 'Deploy, scale & secure modern software systems',
      icon: '☁️',
      gradient: 'from-cyan-600 to-sky-700',
      bgLight: 'bg-cyan-50',
      textColor: 'text-cyan-700',
      demand: 'Very High',
      avgSalary: '₹5L – ₹45L/year',
      globalSalary: '$90K – $220K/year',
      duration: '4 years (B.Tech) + cloud certifications',
      programmingLanguages: ['Python', 'Bash', 'YAML', 'Go'],
      mustKnow: ['Linux', 'Docker', 'Kubernetes', 'AWS / Azure / GCP'],
      topRecruiters: ['Amazon', 'Google', 'Microsoft', 'Oracle', 'Atlassian', 'Infosys', 'TCS', 'Startups'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Learn basic computers and logic', 'Be curious about how apps run on the internet', 'Start with Linux basics and typing practice'], tip: 'System thinking becomes important very early in DevOps' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Choose PCM and keep coding alongside studies', 'Understand networking, OS basics, and cloud ideas', 'Practice Python or Java projects'], tip: 'A strong CS foundation helps more than just tool memorization' },
        { step: 3, title: 'JEE Main / State CET', icon: '📝', duration: 'Jan & Apr', type: 'exam', details: ['Target B.Tech CS / IT / AI / ECE branches', 'DevOps often starts from software engineering pathways', 'Good engineering college gives better internship access'], tip: 'You do not need a DevOps degree, but a strong CS degree helps a lot' },
        { step: 4, title: 'B.Tech in CS / IT', icon: '🎓', duration: '4 years', type: 'education', details: ['Learn Linux, Git, CI/CD, Docker, Kubernetes', 'Understand AWS, Azure, GCP and networking', 'Build deployment pipelines for your projects'], tip: 'DevOps is about reliability, automation, and shipping faster' },
        { step: 5, title: 'Internships / Certifications', icon: '💼', duration: '6 months – 1 year', type: 'training', details: ['Get hands-on with cloud labs and real deployments', 'Certifications: AWS, Azure, Google Cloud, Kubernetes', 'Practice monitoring, logging, and incident response'], tip: 'Certs help, but real projects and automation scripts matter more' },
        { step: 6, title: 'DevOps Job', icon: '🚀', duration: 'Ongoing', type: 'milestone', details: ['Roles: DevOps Engineer, Cloud Engineer, SRE', 'Work with app teams to deploy and scale systems', 'Focus on uptime, security, and automation'], tip: 'Startups and product companies especially value strong DevOps engineers' },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'B.Tech CS / IT / ECE paths' },
        { name: 'BITSAT', month: 'May–Jun', desc: 'BITS Pilani CS / IT' },
        { name: 'VITEEE', month: 'April', desc: 'VIT CS / IT programs' },
        { name: 'MHT-CET', month: 'May', desc: 'State engineering colleges' },
      ],
      topColleges: ['BITS Pilani', 'IIIT Hyderabad', 'NIT Trichy', 'VIT Vellore', 'DTU Delhi', 'PES University', 'RVCE Bangalore'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Junior DevOps / Cloud Engineer', salary: '₹5L – ₹12L' },
        { level: 'Mid (3–5 yrs)', role: 'DevOps Engineer / SRE', salary: '₹12L – ₹25L' },
        { level: 'Senior (6–9 yrs)', role: 'Senior DevOps / Platform Engineer', salary: '₹25L – ₹50L' },
        { level: 'Lead (10+ yrs)', role: 'Cloud Architect / Head of Platform', salary: '₹50L – ₹1.5Cr+' },
      ],
    },
    {
      id: 'electronics-circuit-engineer',
      title: 'Electronics & Circuit Engineer',
      tagline: 'Design circuits, hardware & embedded devices',
      icon: '🔌',
      gradient: 'from-amber-600 to-orange-700',
      bgLight: 'bg-amber-50',
      textColor: 'text-amber-700',
      demand: 'High',
      avgSalary: '₹4L – ₹30L/year',
      globalSalary: '$75K – $160K/year',
      duration: '4 years (B.Tech ECE/EEE)',
      programmingLanguages: ['C', 'C++', 'Python', 'Verilog'],
      mustKnow: ['Circuit theory', 'PCB basics', 'Embedded systems', 'VLSI basics'],
      topRecruiters: ['Intel', 'Qualcomm', 'Texas Instruments', 'Bosch', 'Samsung', 'ISRO', 'DRDO', 'Tata Elxsi'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Build interest in electronics and gadgets', 'Learn basics of maths, science, and simple circuits', 'Do hobby projects like simple LED and sensor kits'], tip: 'A curiosity for how devices work is a great sign' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Choose PCM with strong focus on Physics and Maths', 'Understand electricity, magnetism, and circuit fundamentals', 'Practice basic coding and logical thinking'], tip: 'Physics is the backbone of electronics and circuit design' },
        { step: 3, title: 'JEE Main / State CET', icon: '📝', duration: 'Jan & Apr', type: 'exam', details: ['Target ECE, EEE, EIE, or Electronics branches', 'Use JEE, VITEEE, COMEDK, MHT-CET, KCET', 'Look for colleges with strong labs and placement support'], tip: 'Circuit careers grow best when the college has practical lab exposure' },
        { step: 4, title: 'B.Tech ECE / EEE', icon: '🎓', duration: '4 years', type: 'education', details: ['Study circuit theory, digital electronics, signals, and communication', 'Learn Verilog/VHDL, MATLAB, SPICE, and PCB design basics', 'Build embedded projects with Arduino/Raspberry Pi'], tip: 'Try mini-projects early — hardware skills improve with practice' },
        { step: 5, title: 'Internships & Hardware Projects', icon: '💼', duration: '6 months – 1 year', type: 'training', details: ['Work on embedded systems, sensors, IoT, and PCB design', 'Join robotics clubs, hardware hackathons, and labs', 'Prepare for VLSI / embedded engineering roles'], tip: 'A strong project portfolio can beat many generic resumes' },
        { step: 6, title: 'Electronics / Circuit Job', icon: '🚀', duration: 'Ongoing', type: 'milestone', details: ['Roles: Circuit Design Engineer, Embedded Engineer, VLSI Engineer', 'Industries: chip design, telecom, consumer electronics, defence', 'Growth to product design, research, or hardware architecture'], tip: 'India is growing in semiconductor and hardware design opportunities' },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'B.Tech ECE / EEE / Electronics' },
        { name: 'JEE Advanced', month: 'May', desc: 'IIT Electronics and related branches' },
        { name: 'VITEEE', month: 'April', desc: 'VIT ECE / EEE' },
        { name: 'COMEDK', month: 'May', desc: 'Karnataka private engineering colleges' },
      ],
      topColleges: ['IIT Bombay', 'IIT Delhi', 'IIT Madras', 'NIT Trichy', 'BITS Pilani', 'IIIT Hyderabad', 'VIT Vellore', 'PEC Chandigarh'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Junior Electronics / Embedded Engineer', salary: '₹4L – ₹10L' },
        { level: 'Mid (3–5 yrs)', role: 'Circuit / Hardware Engineer', salary: '₹10L – ₹22L' },
        { level: 'Senior (6–9 yrs)', role: 'VLSI / Embedded Lead Engineer', salary: '₹22L – ₹45L' },
        { level: 'Lead (10+ yrs)', role: 'Hardware Architect / Engineering Manager', salary: '₹45L – ₹1Cr+' },
      ],
    },
    {
      id: 'civil-engineer',
      title: 'Civil Engineer',
      tagline: 'Design roads, bridges, buildings & cities',
      icon: '🏗️',
      gradient: 'from-amber-600 to-orange-700',
      bgLight: 'bg-amber-50',
      textColor: 'text-amber-700',
      demand: 'High',
      avgSalary: '₹3L – ₹25L/year',
      globalSalary: '$60K – $120K/year',
      duration: '4 years (B.Tech Civil)',
      topRecruiters: ['L&T Construction', 'NHAI', 'PWD', 'Gammon India', 'Shapoorji Pallonji', 'ISRO (structures)'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Focus on Maths, Science & Drawing', 'Understand basic geometry & measurements'], tip: 'Civil engineering involves a lot of technical drawing and 3D visualization' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Physics & Maths are most critical', 'Learn AutoCAD basics (optional but beneficial)'], tip: 'Visit construction sites to understand the field early' },
        { step: 3, title: 'JEE Main / State CET', icon: '📝', duration: 'Jan & Apr', type: 'exam', details: ['Clear JEE for B.Tech Civil at NIT/CFTI', 'State CETs: MHT-CET, KCET, WBJEE'], tip: 'Civil engineering seats are more available — even moderate ranks work' },
        { step: 4, title: 'B.Tech Civil Engineering', icon: '🎓', duration: '4 years', type: 'education', details: ['Structural, Geotechnical, Transportation, Env. Engineering', 'AutoCAD, STAAD Pro, REVIT, SAP2000 software', 'Summer internships at construction sites/PWD'], tip: 'Get licensed via GATE/UPSC for Govt engineering posts' },
        { step: 5, title: 'GATE / Govt Exam (optional)', icon: '📝', duration: 'Feb each year', type: 'exam', details: ['GATE Civil → IES (Indian Engineering Services)', 'PSU jobs: CPWD, NHAI, NHPC, ONGC', 'State PSC for state-level engineering posts'], tip: 'IES (civil services for engineers) is highly prestigious with top govt benefits' },
        { step: 6, title: 'Job / Site Engineer', icon: '💼', duration: 'Ongoing', type: 'milestone', details: ['Start as Site Engineer, Structural Designer, or Estimation Engineer', 'Private sector: Builders, contractors, real estate', 'Govt: PWD, BRO, NHAI, Railways, Airports'], tip: 'Real estate & infrastructure boom in India means steady demand' },
        { step: 7, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Junior → Project Engineer → Project Manager → Director', 'Option: Start own consultancy or contracting firm'], tip: 'Civil engineers with 10+ years can earn ₹20L–₹50L in private sector' },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'B.Tech Civil at NIT/IIIT' },
        { name: 'JEE Advanced', month: 'May', desc: 'IIT Civil Engineering' },
        { name: 'GATE', month: 'February', desc: 'M.Tech / PSU / IES (Govt jobs)' },
        { name: 'UPSC IES', month: 'June', desc: 'Indian Engineering Services (IES/ESE)' },
      ],
      topColleges: ['IIT Delhi (Civil)', 'IIT Roorkee (Civil)', 'NIT Trichy', 'BITS Pilani', 'NIT Surathkal', 'COEP Pune', 'SPA Delhi (Architecture)'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Site Engineer / Junior Engineer', salary: '₹3L – ₹8L' },
        { level: 'Mid (3–7 yrs)', role: 'Project Engineer / Design Engineer', salary: '₹8L – ₹18L' },
        { level: 'Senior (8–14 yrs)', role: 'Project Manager / Chief Engineer', salary: '₹18L – ₹40L' },
        { level: 'Top (15+ yrs)', role: 'Director / VP Engineering / Own Firm', salary: '₹40L – ₹1Cr+' },
      ],
    },
    {
      id: 'mechanical-engineer',
      title: 'Mechanical Engineer',
      tagline: 'Design machines, automobiles & manufacturing systems',
      icon: '⚙️',
      gradient: 'from-slate-600 to-gray-700',
      bgLight: 'bg-slate-50',
      textColor: 'text-slate-700',
      demand: 'High',
      avgSalary: '₹3.5L – ₹25L/year',
      globalSalary: '$65K – $130K/year',
      duration: '4 years (B.Tech Mechanical)',
      topRecruiters: ['ISRO', 'DRDO', 'Tata Motors', 'Mahindra', 'L&T', 'Bosch', 'Siemens', 'Boeing India'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Strong in Maths, Physics & Workshop', 'Understand machines around you'], tip: 'If you love cars, bikes, engines — Mechanical is for you' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Physics & Maths — most critical subjects', 'Learn drawing/sketching — engineering drawing matters'], tip: 'Score well in Physics — Mechanics, Thermodynamics are core' },
        { step: 3, title: 'JEE / State CET', icon: '📝', duration: 'Jan & Apr', type: 'exam', details: ['JEE for NIT/IIT Mechanical', 'State exams for local colleges'], tip: 'Mechanical has more seats in most colleges — moderate rank works' },
        { step: 4, title: 'B.Tech Mechanical', icon: '🎓', duration: '4 years', type: 'education', details: ['Thermodynamics, Fluid Mechanics, Design, Manufacturing, CAD/CAM', 'Software: AutoCAD, SolidWorks, ANSYS, CATIA', 'Robotics & Automation specializations growing'], tip: 'Focus on CAD/CAM — software skills boost mechanical engineers salary by 40%' },
        { step: 5, title: 'GATE / Campus Placement', icon: '💼', duration: '6 months', type: 'milestone', details: ['GATE for M.Tech or PSU jobs (BHEL, ISRO, ONGC, NTPC)', 'Campus: Automobile, Manufacturing, Consultancy', 'Core Mech jobs: Maruti, Tata, Hero, TVS'], tip: 'PSU jobs via GATE (BHEL, ISRO) offer ₹8L–₹15L CTC + benefits' },
        { step: 6, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Design Engineer → Senior Designer → R&D Head', 'Specialize: Robotics, Thermal, Aerospace, Automotive'], tip: 'Robotics & automation is the future of Mechanical engineering' },
      ],
      entranceExams: [
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'NIT/IIIT/CFTI Mechanical' },
        { name: 'JEE Advanced', month: 'May', desc: 'IIT Mechanical/Aerospace' },
        { name: 'GATE', month: 'February', desc: 'M.Tech / PSU / ISRO / DRDO' },
        { name: 'VITEEE', month: 'April', desc: 'VIT University Mechanical' },
      ],
      topColleges: ['IIT Bombay (Mech)', 'IIT Madras', 'NIT Trichy', 'BITS Pilani', 'IIT Roorkee', 'VIT Vellore', 'COEP Pune'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Graduate Engineer Trainee / Junior Design Engineer', salary: '₹3L – ₹7L' },
        { level: 'Mid (3–7 yrs)', role: 'Design / Production / R&D Engineer', salary: '₹7L – ₹18L' },
        { level: 'Senior (8–14 yrs)', role: 'Senior Engineer / Project Manager', salary: '₹18L – ₹35L' },
        { level: 'Top (15+ yrs)', role: 'Engineering Head / CTO / Founder', salary: '₹35L – ₹1Cr+' },
      ],
    },
    {
      id: 'aerospace-engineer',
      title: 'Aerospace Engineer',
      tagline: 'Design aircraft, rockets & satellites',
      icon: '🚀',
      gradient: 'from-sky-600 to-blue-700',
      bgLight: 'bg-sky-50',
      textColor: 'text-sky-700',
      demand: 'Moderate — High',
      avgSalary: '₹5L – ₹30L/year',
      globalSalary: '$85K – $180K/year',
      duration: '4 years (B.Tech Aerospace)',
      topRecruiters: ['ISRO', 'DRDO', 'HAL', 'Boeing India', 'Airbus India', 'Air India', 'IndiGo (Engineering)'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Strong in Maths, Physics & Science', 'Interest in space, aircraft & rockets'], tip: 'Follow ISRO missions — builds genuine interest & knowledge' },
        { step: 2, title: '11th–12th PCM', icon: '🔬', duration: '2 years', type: 'education', details: ['Maths & Physics are everything', 'Study fluid mechanics, optics, thermodynamics thoroughly'], tip: 'IIT JEE requires extremely high score for Aerospace at top IITs' },
        { step: 3, title: 'JEE Advanced (IIT)', icon: '📝', duration: 'May', type: 'exam', details: ['IIT Bombay, Madras, Kharagpur offer Aerospace', 'MIT Manipal, SRM also have good Aerospace departments'], tip: 'Alternative: Join ISRO after B.Tech via ICRB recruitment' },
        { step: 4, title: 'B.Tech Aerospace/Aeronautical', icon: '🎓', duration: '4 years', type: 'education', details: ['Aerodynamics, Propulsion, Structural Analysis, Avionics', 'Software: ANSYS Fluent, MATLAB, NASTRAN', 'Projects: Design and test small UAVs/drones'], tip: 'Drone technology is the next big aerospace job creator in India' },
        { step: 5, title: 'M.Tech / MS / GATE', icon: '🎓', duration: '2 years (optional)', type: 'education', details: ['GATE for IIT M.Tech + ISRO/DRDO/HAL recruitment', 'MS from MIT, Stanford, TU Munich for global career'], tip: 'ISRO directly recruits via ICRB — no GATE required' },
        { step: 6, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['ISRO Scientist → Senior Scientist → Project Director', 'Private: HAL, Boeing, Airbus, SpaceX (international)', 'Drone startups: fast growing sector in India'], tip: 'India\'s space budget is growing — ISRO + private sector (Agnikul, Skyroot) are hiring' },
      ],
      entranceExams: [
        { name: 'JEE Advanced', month: 'May', desc: 'IIT Aerospace Engineering' },
        { name: 'JEE Main', month: 'Jan & Apr', desc: 'NIT/IIIT entry level' },
        { name: 'GATE Aerospace (AE)', month: 'February', desc: 'ISRO/DRDO/HAL & M.Tech' },
        { name: 'ICRB (ISRO)', month: 'Various', desc: 'Direct ISRO scientist recruitment' },
      ],
      topColleges: ['IIT Bombay (Aerospace)', 'IIT Madras', 'IIT Kharagpur', 'IIST Thiruvananthapuram', 'PEC Chandigarh', 'MIT Manipal', 'Amity Noida'],
      careerGrowth: [
        { level: 'Entry (0–3 yrs)', role: 'Graduate Engineer / Junior Scientist', salary: '₹5L – ₹10L' },
        { level: 'Mid (4–8 yrs)', role: 'Scientist/Engineer SC/SD', salary: '₹10L – ₹22L' },
        { level: 'Senior (9–15 yrs)', role: 'Project Director / Senior Scientist', salary: '₹22L – ₹45L' },
        { level: 'Top (15+ yrs)', role: 'Distinguished Scientist / Director', salary: '₹45L – ₹80L' },
      ],
    },
  ],

  // ── PCB CAREERS ─────────────────────────────────────────────────────────────
  pcb: [
    {
      id: 'mbbs-doctor',
      title: 'MBBS Doctor',
      tagline: 'Heal patients, save lives, serve society',
      icon: '👨‍⚕️',
      gradient: 'from-rose-600 to-pink-700',
      bgLight: 'bg-rose-50',
      textColor: 'text-rose-700',
      demand: 'Very High',
      avgSalary: '₹8L – ₹1Cr+/year',
      globalSalary: '$120K – $400K+/year',
      duration: '5.5 years (MBBS) + specialization',
      topRecruiters: ['AIIMS', 'Apollo', 'Fortis', 'Max Hospital', 'Govt Hospitals', 'WHO', 'Private Practice'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Excel in Science — Biology & Chemistry especially', 'Develop empathy, communication, patience', 'Visit hospitals to understand the field'], tip: 'Early interest in biology is a strong indicator for medical career' },
        { step: 2, title: '11th–12th PCB', icon: '🔬', duration: '2 years', type: 'education', details: ['Biology, Chemistry, Physics — all equally important', 'Start NEET preparation from 11th itself', 'Join reputed NEET coaching (Allen, Aakash, FIITJEE Medical)'], tip: 'NEET is highly competitive — 18L+ students for limited seats. Start early.' },
        { step: 3, title: 'NEET-UG Exam', icon: '📝', duration: 'May each year', type: 'exam', details: ['720 marks exam: Biology (360) + Physics (180) + Chemistry (180)', 'Need 600+ for Govt MBBS | 550+ for private', 'AIIMS, JIPMER included in NEET now', 'Multiple attempts allowed'], tip: 'Consistent NCERT study + PYQ practice is the winning strategy for NEET' },
        { step: 4, title: 'MBBS Degree', icon: '🎓', duration: '5.5 years (4.5 + 1 yr internship)', type: 'education', details: ['12 terms covering all medical specialties', '1 year compulsory rotational internship', 'Learn: Anatomy, Physiology, Pharmacology, Surgery, Medicine', 'Exposure to all hospital departments'], tip: 'Work hard in clinical years (3rd–5th year) — practical skills matter most' },
        { step: 5, title: 'NEET-PG / Specialization', icon: '📝', duration: 'Jan each year', type: 'exam', details: ['NEET-PG for MD/MS/Diploma specialization', 'Top specializations: Surgery, Ortho, Cardiology, Derma, Radiology', 'General Practice option: Start clinic directly after MBBS'], tip: 'Super-specialization (DM/MCh) makes you an expert with ₹50L+ income potential' },
        { step: 6, title: 'MD / MS (Specialization)', icon: '🎓', duration: '3 years', type: 'education', details: ['MD: Medicine specialties (Cardiology, Neuro, Pediatrics)', 'MS: Surgery specialties (Orthopedics, ENT, Ophthalmology)', 'DNB: National Board certification from hospitals'], tip: 'Dermatology, Radiology, Ophthalmology have best work-life balance' },
        { step: 7, title: 'Career & Practice', icon: '🚀', duration: 'Lifetime', type: 'growth', details: ['Govt Hospital: UPSC / State PSC for Medical Officer posts', 'Private Hospital: Apollo, Fortis, Max — ₹15L–₹1Cr/year', 'Own Clinic / Nursing Home: Highest income potential', 'International: UK (PLAB), USA (USMLE), Australia (AMC)'], tip: 'India faces doctor shortage — job security is guaranteed for life' },
      ],
      entranceExams: [
        { name: 'NEET-UG', month: 'May', desc: 'Single exam for all MBBS/BDS/BAMS/BHMS/BVSc seats in India' },
        { name: 'NEET-PG', month: 'January', desc: 'MD/MS/Diploma specialization after MBBS' },
        { name: 'USMLE (USA)', month: 'Year-round', desc: 'Practice in United States' },
        { name: 'PLAB (UK)', month: 'Year-round', desc: 'Practice in United Kingdom' },
      ],
      topColleges: ['AIIMS Delhi', 'AIIMS Mumbai', 'CMC Vellore', 'JIPMER', 'Maulana Azad MC Delhi', 'BHU Varanasi', 'AFMC Pune', 'KMC Manipal'],
      careerGrowth: [
        { level: 'MBBS + Internship', role: 'Junior Resident / MBBS Doctor', salary: '₹3L – ₹8L' },
        { level: 'MD/MS (Specialist)', role: 'Specialist Doctor', salary: '₹12L – ₹40L' },
        { level: 'Senior Specialist', role: 'Senior Consultant / HOD', salary: '₹30L – ₹1Cr' },
        { level: 'Super Specialist', role: 'DM/MCh Super-Specialist / Own Practice', salary: '₹60L – ₹3Cr+' },
      ],
    },
    {
      id: 'pharmacist',
      title: 'Pharmacist (B.Pharma)',
      tagline: 'Drug science, clinical care & pharmaceutical industry',
      icon: '💊',
      gradient: 'from-emerald-600 to-teal-700',
      bgLight: 'bg-emerald-50',
      textColor: 'text-emerald-700',
      demand: 'Very High',
      avgSalary: '₹3L – ₹20L/year',
      globalSalary: '$60K – $130K/year',
      duration: '4 years (B.Pharma) or 2 years (D.Pharma)',
      topRecruiters: ['Sun Pharma', 'Cipla', 'Dr. Reddy\'s', 'Apollo Pharmacy', 'Pfizer', 'AIIMS Hospital Pharmacy'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Focus on Chemistry, Biology, Maths', 'Interest in medicines, drugs, and healthcare', 'Science foundation is crucial'], tip: 'India is the world\'s largest generic medicine producer — massive industry' },
        { step: 2, title: '11th–12th PCM or PCB', icon: '🔬', duration: '2 years', type: 'education', details: ['PCB or PCM both accepted', 'Chemistry is the most important subject', 'Biology helps for clinical pharmacy'], tip: 'D.Pharma (2 years) can be done right after 12th for quick employment' },
        { step: 3, title: 'D.Pharma or B.Pharma CET', icon: '📝', duration: 'May–Jun', type: 'exam', details: ['D.Pharma: 2-year diploma — quick job entry', 'B.Pharma: 4-year degree — better career progression', 'State CETs: MHT-CET Pharma, UPSEE, TS EAMCET'], tip: 'B.Pharma > D.Pharma for long-term career growth' },
        { step: 4, title: 'B.Pharma Degree', icon: '🎓', duration: '4 years', type: 'education', details: ['Subjects: Pharmacology, Medicinal Chemistry, Clinical Pharmacy, Regulatory Affairs', 'Internship at hospital pharmacy or pharma company', 'Register with State Pharmacy Council'], tip: 'Industrial pharma (Sun, Cipla, Dr Reddy\'s) offers great packages for B.Pharma graduates' },
        { step: 5, title: 'GPAT / M.Pharma (optional)', icon: '📝', duration: 'Feb each year', type: 'exam', details: ['GPAT: Graduate Pharmacy Aptitude Test for M.Pharma admission', 'M.Pharma specializations: Pharma Chemistry, Clinical, Regulatory', 'Job options: QC/QA, R&D, Medical Affairs'], tip: 'Regulatory Affairs & Pharmacovigilance are highest-paid niche areas' },
        { step: 6, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Hospital Pharmacist → Clinical Pharmacist → Pharmacy Manager', 'Industry: Drug Inspector, QC Officer, MR (Medical Representative)', 'Own: Medical store, online pharmacy', 'Global: USA/UK/Australia Pharmacy licensure exams'], tip: 'UK/Australia pharmacists earn ₹40L–₹80L — excellent migration pathway' },
      ],
      entranceExams: [
        { name: 'MHT-CET Pharma', month: 'May', desc: 'Maharashtra B.Pharma admissions' },
        { name: 'UPSEE', month: 'April', desc: 'UP state pharmacy colleges' },
        { name: 'GPAT', month: 'February', desc: 'M.Pharma admissions' },
        { name: 'TS EAMCET', month: 'May', desc: 'Telangana pharmacy colleges' },
      ],
      topColleges: ['Jamia Hamdard Delhi', 'BITS Pilani (Pharma)', 'ICT Mumbai', 'JSS Mysore', 'Manipal Pharmacy', 'Bombay College of Pharmacy'],
      careerGrowth: [
        { level: 'D.Pharma Entry', role: 'Pharmacist / Medical Store', salary: '₹2L – ₹5L' },
        { level: 'B.Pharma (0–3 yrs)', role: 'Clinical/Hospital/Industrial Pharmacist', salary: '₹3L – ₹10L' },
        { level: 'Mid (4–8 yrs)', role: 'QC Manager / Drug Inspector / R&D Scientist', salary: '₹8L – ₹20L' },
        { level: 'Senior (8+ yrs)', role: 'Regulatory Director / Head of Pharmacy', salary: '₹18L – ₹50L' },
      ],
    },
    {
      id: 'bsc-nursing',
      title: 'B.Sc Nursing',
      tagline: 'Frontline healthcare — India and abroad',
      icon: '💉',
      gradient: 'from-pink-500 to-rose-600',
      bgLight: 'bg-pink-50',
      textColor: 'text-pink-700',
      demand: 'Very High',
      avgSalary: '₹2.5L – ₹15L/year (India) | ₹30L–₹70L (Abroad)',
      globalSalary: '$60K – $120K/year',
      duration: '4 years (B.Sc Nursing)',
      topRecruiters: ['AIIMS', 'Apollo', 'NHS UK', 'US Hospitals', 'Gulf Hospitals', 'Armed Forces'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Good in Biology, Chemistry', 'Empathy and people skills important', 'Understand basic healthcare concepts'], tip: 'Nursing is in high demand globally — excellent overseas migration pathway' },
        { step: 2, title: '11th–12th PCB', icon: '🔬', duration: '2 years', type: 'education', details: ['Biology & Chemistry most important', 'Min 45–50% in 12th PCB required', 'GNM (3.5 yr) can be done if NEET not cleared'], tip: 'ANM (2yr) is another option for girls after 12th for quick employment' },
        { step: 3, title: 'Nursing CET / Direct', icon: '📝', duration: 'May–Jun', type: 'exam', details: ['State nursing CETs for B.Sc Nursing admissions', 'JIPMER, AIIMS nursing entrance exams', 'GNM/ANM: Some states offer direct merit-based admission'], tip: 'NEET score is used for B.Sc Nursing in some states' },
        { step: 4, title: 'B.Sc Nursing (4 years)', icon: '🎓', duration: '4 years', type: 'education', details: ['Medical-Surgical, Pediatrics, Maternity, Psychiatric Nursing', 'Clinical rotations at major hospitals from 2nd year', 'Register with Indian Nursing Council (INC)'], tip: 'Hospital clinical training is the most valuable part — take it seriously' },
        { step: 5, title: 'India / Abroad Placement', icon: '💼', duration: 'Ongoing', type: 'milestone', details: ['India: AIIMS, Apollo, Fortis, Govt hospitals (₹3L–₹12L)', 'UK: IELTS + NMC registration → £35K–£50K', 'USA: NCLEX exam → $70K–$100K', 'Middle East: DHA/HAAD license → ₹25L–₹50L'], tip: 'IELTS 7.0+ opens UK/Australia nursing migration — fastest pathway to high income' },
        { step: 6, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Staff Nurse → Senior Nurse → Nursing Supervisor → Chief Nursing Officer', 'Specializations: ICU, NICU, OR, Oncology, Emergency Nursing', 'Option: M.Sc Nursing → Nurse Educator / Researcher'], tip: 'UK and Canada have acute nursing shortages — Indian nurses are in very high demand' },
      ],
      entranceExams: [
        { name: 'NEET-UG', month: 'May', desc: 'Some state nursing admissions via NEET' },
        { name: 'AIIMS Nursing', month: 'June', desc: 'AIIMS B.Sc Nursing entrance' },
        { name: 'JIPMER Nursing', month: 'June', desc: 'JIPMER B.Sc Nursing' },
        { name: 'NCLEX-RN (USA)', month: 'Year-round', desc: 'US nursing license exam' },
        { name: 'NMC (UK)', month: 'Year-round', desc: 'UK Nursing & Midwifery Council registration' },
      ],
      topColleges: ['AIIMS Delhi (Nursing)', 'JIPMER Nursing', 'CMC Vellore', 'MAHE Manipal', 'Jamia Hamdard', 'SRM Nursing College', 'AFMC Pune'],
      careerGrowth: [
        { level: 'Entry (0–3 yrs)', role: 'Staff Nurse', salary: '₹2.5L – ₹7L' },
        { level: 'Mid (4–8 yrs)', role: 'Senior Nurse / ICU Specialist', salary: '₹7L – ₹15L (India) | ₹30L+ (abroad)' },
        { level: 'Senior (8+ yrs)', role: 'Nursing Supervisor / Department Head', salary: '₹12L – ₹25L' },
        { level: 'International', role: 'NHS UK / US Hospital Nurse', salary: '₹40L – ₹80L equivalent' },
      ],
    },
  ],

  // ── COMMERCE CAREERS ─────────────────────────────────────────────────────────
  'commerce-12': [
    {
      id: 'chartered-accountant',
      title: 'Chartered Accountant (CA)',
      tagline: 'India\'s most prestigious finance certification',
      icon: '🏦',
      gradient: 'from-blue-600 to-indigo-700',
      bgLight: 'bg-blue-50',
      textColor: 'text-blue-700',
      demand: 'Very High',
      avgSalary: '₹6L – ₹60L+/year',
      globalSalary: '$80K – $200K/year',
      duration: '4–5 years (Foundation to Final)',
      topRecruiters: ['Big 4 (Deloitte, PwC, EY, KPMG)', 'All MNCs', 'Govt (UPSC)', 'Banks', 'Own Practice'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Focus on Maths & Accounts fundamentals', 'Develop analytical & number skills', 'Join Commerce stream'], tip: 'CA Foundation can be registered while in 12th — plan early' },
        { step: 2, title: '11th–12th Commerce', icon: '📊', duration: '2 years', type: 'education', details: ['Accounts, Business Studies, Economics, Maths', 'Maintain 75%+ for competitive edge', 'Start CA Foundation study during 12th'], tip: 'Register for CA Foundation with ICAI while in 12th grade (after Nov of 11th)' },
        { step: 3, title: 'CA Foundation', icon: '📝', duration: '6–8 months (exam May/Nov)', type: 'exam', details: ['4 papers: Accounting, Business Law, Maths/Stats, Business Economics', 'Pass percentage: ~30–40%', 'Can attempt after 12th results'], tip: 'Foundation can be cleared in first attempt with 3–4 months dedicated study' },
        { step: 4, title: 'CA Intermediate', icon: '📝', duration: '1–2 years', type: 'exam', details: ['2 Groups, 6 papers total', 'Advanced Accounting, Audit, Taxation, Corporate Law, Cost & FM', 'Both groups need 40% per paper + 50% aggregate', 'This is the toughest level — most failures here'], tip: 'Study each subject daily — don\'t leave anything for last 2 months' },
        { step: 5, title: '3 Years Articleship', icon: '🏢', duration: '3 years', type: 'training', details: ['Mandatory practical training under a CA firm', 'Stipend: ₹5K–₹30K/month depending on firm', 'Big 4 articleship → best career start', 'Learn: Audit, Taxation, Compliance, Finance in practice'], tip: 'Big 4 articleship (EY, Deloitte, PwC, KPMG) is gold on your CV' },
        { step: 6, title: 'CA Final', icon: '📝', duration: '6 months–2 years', type: 'exam', details: ['2 Groups, 6 papers (toughest level in any Indian exam)', 'Financial Reporting, Strategic FM, Audit, Direct Tax, Indirect Tax, Electives', 'Overall pass rate: ~10–15%', 'Can attempt while last 6 months of articleship'], tip: 'Be patient — many top CAs cleared Final in 2nd or 3rd attempt. Keep going.' },
        { step: 7, title: 'ACA → FCA → Growth', icon: '🚀', duration: 'Lifetime', type: 'growth', details: ['ACA: Become ICAI member after final pass', 'FCA: Fellow after 5 years of practice', 'Options: Big 4 → CFO path, Own CA Firm, UPSC, SEBI/RBI'], tip: 'Young CAs (under 24) at Big 4 start at ₹6L–₹10L; top performers reach ₹40L in 5 years' },
      ],
      entranceExams: [
        { name: 'CA Foundation', month: 'May & November', desc: 'ICAI Foundation exam — entry to CA course' },
        { name: 'CA Intermediate', month: 'May & November', desc: '2 groups, 6 papers' },
        { name: 'CA Final', month: 'May & November', desc: 'Final qualification exam' },
        { name: 'CPA (USA)', month: 'Year-round', desc: 'US CPA after Indian CA for global recognition' },
      ],
      topColleges: ['ICAI (Institute of Chartered Accountants of India)', 'ICAI learning centres in all cities', 'Big 4 articleship firms (EY, PwC, KPMG, Deloitte)'],
      careerGrowth: [
        { level: 'Freshly Qualified CA', role: 'CA Associate / Tax / Audit Professional', salary: '₹6L – ₹12L' },
        { level: '3–5 years post CA', role: 'Manager / Senior CA', salary: '₹12L – ₹30L' },
        { level: '6–10 years', role: 'Partner / Finance Manager / CFO', salary: '₹25L – ₹70L' },
        { level: 'Own Firm / CFO', role: 'FCA / CFO / Finance Director', salary: '₹40L – ₹2Cr+' },
      ],
    },
    {
      id: 'investment-banker',
      title: 'Investment Banker',
      tagline: 'Finance deals, markets & corporate growth',
      icon: '📈',
      gradient: 'from-cyan-600 to-blue-700',
      bgLight: 'bg-cyan-50',
      textColor: 'text-cyan-700',
      demand: 'High',
      avgSalary: '₹5L – ₹80L/year',
      globalSalary: '$100K – $500K+/year',
      duration: '3 yrs BBA + 2 yrs MBA (or CFA)',
      topRecruiters: ['Goldman Sachs', 'Morgan Stanley', 'JP Morgan', 'Kotak Investment Banking', 'ICICI Securities', 'Axis Capital'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Strong in Maths & Economics basics', 'Follow stock markets, business news (CNBC, ET)'], tip: 'Start following stock market from school — builds instinct for finance' },
        { step: 2, title: '11th–12th Commerce', icon: '📊', duration: '2 years', type: 'education', details: ['Accounts, Business Studies, Economics, Maths (mandatory)', 'Maintain 85%+ for top BBA/Economics colleges', 'Practice reading annual reports, financial news'], tip: 'DU B.Com (H) from SRCC/LSR is a strong path to investment banking' },
        { step: 3, title: 'BBA / B.Com (H) / Economics', icon: '📝', duration: '3 years', type: 'education', details: ['IPMAT → IIM Indore/Rohtak (Integrated MBA 5yr)', 'DU JAT → SRCC, LSR, Ramjas for BBA/B.Com', 'Symbiosis SET → Symbiosis BBA Pune'], tip: 'IIM Indore IPM (5-year) gives IIM brand without needing CAT!' },
        { step: 4, title: 'Internships & CFA Level 1', icon: '🏢', duration: 'During graduation', type: 'training', details: ['Intern at ICICI, HDFC, Kotak Securities, Motilal Oswal', 'CFA Level 1 after graduation boosts chances', 'Learn Bloomberg terminal, Excel financial modeling, valuation'], tip: 'CFA (Chartered Financial Analyst) is the gold standard for finance globally' },
        { step: 5, title: 'MBA Finance (IIM/ISB/FMS)', icon: '🎓', duration: '2 years', type: 'education', details: ['CAT → IIM A/B/C for investment banking lateral placements', 'ISB Hyderabad is top for finance in India', 'Top MBAs get ₹20L–₹70L starting packages'], tip: 'IIM Ahmedabad → Goldman Sachs/McKinsey is a reality with top CGPA' },
        { step: 6, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Analyst → Associate → VP → Director → MD', 'IB path: M&A, Equity Research, Debt Capital Markets, IPO', 'International: London, Singapore, New York finance hubs'], tip: 'Top investment bankers in India earn ₹1Cr–₹5Cr+ in bonuses alone' },
      ],
      entranceExams: [
        { name: 'IPMAT', month: 'May', desc: 'IIM Indore/Rohtak integrated 5-year MBA' },
        { name: 'DU JAT', month: 'June', desc: 'Delhi University BBA / BMS admissions' },
        { name: 'CAT', month: 'November', desc: 'IIM MBA admissions (for MBA Finance)' },
        { name: 'CFA Level 1', month: 'Feb/May/Aug/Nov', desc: 'Global finance certification' },
      ],
      topColleges: ['IIM Ahmedabad (MBA)', 'ISB Hyderabad', 'IIM Calcutta', 'FMS Delhi', 'SRCC Delhi (B.Com)', 'IIM Indore (IPM)', 'NMIMS Mumbai'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Financial Analyst / Research Analyst', salary: '₹5L – ₹15L' },
        { level: 'Mid (3–6 yrs)', role: 'Investment Banking Associate / VP', salary: '₹15L – ₹50L' },
        { level: 'Senior (7–12 yrs)', role: 'Director / Senior Banker', salary: '₹40L – ₹1Cr+' },
        { level: 'Top (12+ yrs)', role: 'Managing Director / Partner', salary: '₹1Cr – ₹10Cr+ (with bonus)' },
      ],
    },
    {
      id: 'business-manager',
      title: 'Business Manager (BBA + MBA)',
      tagline: 'Lead teams, brands and entire organizations',
      icon: '🏢',
      gradient: 'from-indigo-600 to-violet-700',
      bgLight: 'bg-indigo-50',
      textColor: 'text-indigo-700',
      demand: 'Very High',
      avgSalary: '₹4L – ₹50L+/year',
      globalSalary: '$70K – $200K+/year',
      duration: '3 yrs BBA + 2 yrs MBA',
      topRecruiters: ['Unilever', 'P&G', 'Nestle', 'Amazon', 'McKinsey', 'BCG', 'Bain & Company', 'TCS', 'Reliance'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Develop communication & leadership skills', 'Join school clubs, debates, student council'], tip: 'Soft skills are as important as academic marks for business careers' },
        { step: 2, title: '11th–12th Commerce/Any', icon: '📊', duration: '2 years', type: 'education', details: ['Commerce preferred, Arts/Science also work for BBA/MBA', 'Focus on English, Economics, Business Studies', 'Extracurriculars matter for top BBA admissions'], tip: 'IPMAT from IIM Indore is the dream path — starts preparing from 10th itself' },
        { step: 3, title: 'BBA Entrance Exams', icon: '📝', duration: 'Mar–Jun', type: 'exam', details: ['IPMAT: IIM Indore 5-year integrated MBA', 'Symbiosis SET: BBA at Symbiosis Pune', 'DU JAT: BBA/BMS at Delhi University', 'Christ University entrance, NMIMS CET'], tip: 'BBA from IIM Indore/Christ/Symbiosis + MBA from top IIM = ₹20L+ first job' },
        { step: 4, title: 'BBA Degree', icon: '🎓', duration: '3 years', type: 'education', details: ['Marketing, HR, Finance, Operations specializations', 'Internships at startups and MNCs from 2nd year', 'Build leadership through college fests, clubs'], tip: 'Leadership positions in college fest carry significant weight in IIM applications' },
        { step: 5, title: 'CAT / GMAT Prep', icon: '📝', duration: '6–12 months', type: 'exam', details: ['CAT: IIM entrance (Verbal, DI, QA)', '99%ile → IIM A/B/C → ₹25L–₹70L package', 'GMAT: International MBA at Harvard, INSEAD, ISB'], tip: 'Top 1% of CAT gets into IIM A/B/C. 90%ile gets IIM L/K/I/S — all excellent' },
        { step: 6, title: 'MBA Degree (IIM/ISB)', icon: '🎓', duration: '2 years', type: 'education', details: ['IIM A/B/C: ₹25L–₹80L campus placements', 'Consulting, FMCG, Finance, Tech Management tracks', 'International exchange programs available'], tip: 'IIM placement packages 2026: Avg ₹35L (IIM A) — Highest ₹4Cr (Google, McKinsey)' },
        { step: 7, title: 'Career Growth', icon: '🚀', duration: 'Lifetime', type: 'growth', details: ['Management Trainee → Manager → Sr Manager → GM → VP → CEO', 'Consulting → Strategy → Business Head', 'Entrepreneurship after gaining 5–7 years experience'], tip: 'CEOs of India\'s top companies mostly have IIM/IIT background' },
      ],
      entranceExams: [
        { name: 'IPMAT', month: 'May', desc: 'IIM Indore 5-year BBA+MBA' },
        { name: 'DU JAT', month: 'June', desc: 'Delhi University BBA/BMS' },
        { name: 'Symbiosis SET', month: 'May', desc: 'Symbiosis BBA Pune' },
        { name: 'CAT', month: 'November', desc: 'IIM MBA admissions' },
        { name: 'XAT', month: 'January', desc: 'XLRI & 150+ MBA colleges' },
      ],
      topColleges: ['IIM Ahmedabad', 'IIM Bangalore', 'IIM Calcutta', 'ISB Hyderabad', 'IIM Indore (IPM)', 'FMS Delhi', 'XLRI Jamshedpur', 'MDI Gurgaon'],
      careerGrowth: [
        { level: 'Entry BBA (0–2 yrs)', role: 'Business Analyst / Management Trainee', salary: '₹4L – ₹10L' },
        { level: 'MBA Fresher', role: 'Management Consultant / Brand Manager', salary: '₹10L – ₹40L' },
        { level: 'Mid (4–8 yrs)', role: 'Senior Manager / Product Head', salary: '₹20L – ₹60L' },
        { level: 'Senior (10+ yrs)', role: 'VP / Director / CEO', salary: '₹50L – ₹5Cr+' },
      ],
    },
  ],

  // ── ARTS / HUMANITIES CAREERS ─────────────────────────────────────────────────
  'arts-12': [
    {
      id: 'lawyer',
      title: 'Lawyer / Advocate',
      tagline: 'Fight for justice, rights & the constitution',
      icon: '⚖️',
      gradient: 'from-amber-600 to-orange-700',
      bgLight: 'bg-amber-50',
      textColor: 'text-amber-700',
      demand: 'High',
      avgSalary: '₹3L – ₹50L+/year',
      globalSalary: '$60K – $200K+/year',
      duration: '5 years (BA LLB / BBA LLB)',
      topRecruiters: ['Supreme Court', 'High Courts', 'AZB Partners', 'Cyril Amarchand', 'Shardul Amarchand', 'Luthra & Luthra'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Excellent communication, reasoning, debating skills', 'Read newspapers daily — stay updated on current affairs', 'Excel in English, Social Science'], tip: 'Participate in MUN, debates, mock courts in school — invaluable for law' },
        { step: 2, title: '11th–12th (Any Stream)', icon: '📊', duration: '2 years', type: 'education', details: ['Arts: History, Political Science, Economics ideal', 'Science or Commerce also accepted for LLB/BA LLB', 'Maintain 75%+ for NLU eligibility'], tip: 'CLAT is open to ALL streams — Science & Commerce students also do well' },
        { step: 3, title: 'CLAT / AILET Exam', icon: '📝', duration: 'December each year', type: 'exam', details: ['CLAT: Common Law Admission Test for 25 NLUs', 'AILET: NLU Delhi separate exam', 'Sections: English, GK, Logical Reasoning, Legal Reasoning, Maths', '~60,000 students for ~2,500 seats at top NLUs'], tip: 'NLU Delhi → AILET is the most coveted. NLS Bangalore (NLSIU) via CLAT is #1.' },
        { step: 4, title: 'BA LLB / BBA LLB (5 years)', icon: '🎓', duration: '5 years', type: 'education', details: ['Constitutional Law, Criminal Law, Contract Law, Company Law, IP Law', 'Moot courts & legal drafting are critical skills', 'Join law review journals, participate in national moot court competitions', 'Intern at law firms, High Court/Supreme Court from 3rd year'], tip: 'NLSIU Bangalore & NLU Delhi placement: ₹15L–₹35L at top corporate law firms' },
        { step: 5, title: 'Bar Council Enrolment', icon: '📋', duration: 'After graduation', type: 'milestone', details: ['Enrol with State Bar Council to practice in India', 'AIBE (All India Bar Exam): Qualifying exam for advocacy', 'Start practice at District Court / High Court'], tip: 'Corporate law at top firms pays ₹15L–₹40L. Own practice takes 5+ years to build.' },
        { step: 6, title: 'Specialization + LLM', icon: '🎓', duration: '1–2 years (optional)', type: 'education', details: ['LLM in Corporate Law, Criminal Law, IP Law, Tax Law, International Law', 'Top LLM: NLU Delhi, NALSAR, NUS Singapore, LSE London, Harvard', 'Judiciary: State PCS Judicial / HJS exam for becoming Judge'], tip: 'Judiciary is extremely prestigious. A Sessions Judge earns ₹1.2Cr package with govt perks' },
        { step: 7, title: 'Career Growth', icon: '🚀', duration: 'Lifetime', type: 'growth', details: ['Junior Associate → Associate → Senior Associate → Partner at top law firm', 'Judiciary: District Judge → High Court Judge → Supreme Court Judge', 'Corporate: Legal Head / General Counsel / Chief Legal Officer'], tip: 'Partners at top Indian law firms earn ₹1Cr–₹5Cr annually' },
      ],
      entranceExams: [
        { name: 'CLAT', month: 'December', desc: 'For 25 NLUs — most important law exam' },
        { name: 'AILET', month: 'December', desc: 'NLU Delhi (NLUD) — separate exam' },
        { name: 'LSAT India', month: 'January/June', desc: 'Symbiosis, Jindal, UPES law schools' },
        { name: 'Symbiosis LAT', month: 'May', desc: 'Symbiosis Law School Pune & Noida' },
        { name: 'AIBE', month: 'After Graduation', desc: 'All India Bar Exam for advocacy' },
      ],
      topColleges: ['NLSIU Bangalore', 'NLU Delhi (NLUD)', 'NALSAR Hyderabad', 'NUJS Kolkata', 'NLU Jodhpur', 'Jindal Global Law School', 'Symbiosis Law School Pune'],
      careerGrowth: [
        { level: 'Junior (0–3 yrs)', role: 'Junior Associate / Court Clerk', salary: '₹3L – ₹8L' },
        { level: 'Mid (4–8 yrs)', role: 'Associate / Senior Associate', salary: '₹8L – ₹25L' },
        { level: 'Senior (8–15 yrs)', role: 'Senior Partner / Legal Counsel', salary: '₹25L – ₹1Cr' },
        { level: 'Top (15+ yrs)', role: 'Managing Partner / Judge / CLO', salary: '₹1Cr – ₹5Cr+' },
      ],
    },
    {
      id: 'ias-ips',
      title: 'IAS / IPS Officer (Civil Services)',
      tagline: 'Run India — the most powerful job in the country',
      icon: '🏛️',
      gradient: 'from-slate-700 to-gray-800',
      bgLight: 'bg-slate-50',
      textColor: 'text-slate-700',
      demand: 'High (Most Competitive)',
      avgSalary: '₹8L – ₹25L+ (+ massive benefits)',
      globalSalary: 'Government service — power, prestige, perks',
      duration: '3 years graduation + 1–3 years UPSC prep',
      topRecruiters: ['Government of India', 'State Governments', 'UN agencies (after IFS)'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['All-round student — Maths, English, Social Science', 'Read NCERT books deeply — UPSC uses them', 'Stay updated with national & international news'], tip: 'UPSC toppers usually read NCERT from 6th–12th 3–4 times each' },
        { step: 2, title: '11th–12th (Any Stream)', icon: '📊', duration: '2 years', type: 'education', details: ['Arts ideal (History, Polity, Geography useful)', 'Science/Commerce also fine — subject choice for UPSC optional later', 'Read newspapers (The Hindu, Indian Express) daily'], tip: 'Daily newspaper reading habit from 11th is the first step to IAS success' },
        { step: 3, title: 'Graduation (Any Degree)', icon: '🎓', duration: '3 years', type: 'education', details: ['Any degree qualifies: BA, B.Com, B.Sc, B.Tech, MBBS', 'Choose optional subject carefully (History, Sociology, PSIR, Geography popular)', 'Start UPSC prep in parallel from 2nd year of graduation', 'Read NCERT 6th–12th (all subjects) thoroughly'], tip: 'IAS toppers mostly have backgrounds in Arts or taken humanities optional subjects' },
        { step: 4, title: 'UPSC CSE Prelims', icon: '📝', duration: 'June each year', type: 'exam', details: ['2 papers: GS Paper 1 (200 marks, qualifying) + CSAT (200 marks, qualifying)', 'Only ~12,000–15,000 qualify from ~10 lakh applicants', 'Syllabus: History, Geography, Polity, Economy, Science, Environment'], tip: 'CSAT Paper is qualifying only — don\'t neglect it though' },
        { step: 5, title: 'UPSC CSE Mains', icon: '📝', duration: 'September each year', type: 'exam', details: ['9 papers + 1 Essay + 4 GS papers + 2 Optional papers + 2 qualifying', 'Total: 1750 marks', '~2,500 qualify for interview'], tip: 'Mains is where the real battle is — writing practice is everything' },
        { step: 6, title: 'Personality Test (Interview)', icon: '🎯', duration: 'February–May', type: 'milestone', details: ['275 marks interview by UPSC board', 'Total ~1,000 selected for IAS/IPS/IFS/other services', 'Final merit = Mains + Interview', '~900 vacancies across all services annually'], tip: 'Average age of toppers: 25–26. Most crack it in 2nd or 3rd attempt' },
        { step: 7, title: 'LBSNAA Training + Posting', icon: '🚀', duration: 'Lifetime', type: 'growth', details: ['LBSNAA Mussoorie training: 2 years', 'Sub-District Magistrate → District Magistrate → Commissioner → Secretary → Cabinet Secretary', 'IPS: ASP → SP → DIG → IG → DGP', 'Power to change lives of millions directly'], tip: 'An IAS DM controls a budget of ₹5,000Cr+ and governs a district of 30+ lakh people' },
      ],
      entranceExams: [
        { name: 'UPSC CSE Prelims', month: 'June', desc: 'Civil Services Exam — IAS/IPS/IFS' },
        { name: 'UPSC CSE Mains', month: 'September', desc: '9-paper written examination' },
        { name: 'State PSC', month: 'Varies by state', desc: 'State Civil Services (SDM, DSP level)' },
        { name: 'UPSC CAPF', month: 'August', desc: 'Central Armed Police Forces (Assistant Commandant)' },
      ],
      topColleges: ['Any Graduation accepted. Most IAS officers: Delhi University, JNU, IIT, Medical colleges', 'Coaching: Vajiram, Vision IAS, Forum IAS, Shankar IAS (Chennai)'],
      careerGrowth: [
        { level: 'Year 1–3', role: 'Sub-Divisional Magistrate / ASP', salary: '₹56,100 basic + DA + HRA + perks' },
        { level: 'Year 4–10', role: 'District Magistrate (IAS) / SP (IPS)', salary: '₹67,700 – ₹1,18,500 basic' },
        { level: 'Year 11–25', role: 'Commissioner / Principal Secretary', salary: '₹1,44,200 – ₹2,05,400 basic' },
        { level: 'Top Level', role: 'Chief Secretary / Cabinet Secretary', salary: '₹2,50,000 basic + all Govt benefits' },
      ],
    },
    {
      id: 'fashion-designer',
      title: 'Fashion Designer',
      tagline: 'Create clothes, brands and cultural trends',
      icon: '👗',
      gradient: 'from-pink-600 to-purple-700',
      bgLight: 'bg-pink-50',
      textColor: 'text-pink-700',
      demand: 'Growing',
      avgSalary: '₹2.5L – ₹30L/year',
      globalSalary: '$50K – $200K/year',
      duration: '4 years (B.Des Fashion from NIFT)',
      topRecruiters: ['Manish Malhotra', 'Sabyasachi', 'H&M', 'Zara India', 'FabIndia', 'Myntra', 'Amazon Fashion'],
      roadmap: [
        { step: 1, title: '10th Grade', icon: '📚', duration: '2 years', type: 'education', details: ['Develop drawing, sketching, colour sense', 'Study textiles, fabrics, design history', 'Build a portfolio of fashion sketches'], tip: 'Start a fashion sketchbook — NIFT interview gives massive weightage to portfolio' },
        { step: 2, title: '11th–12th (Any Stream)', icon: '📊', duration: '2 years', type: 'education', details: ['Any stream acceptable for NIFT/NID', 'Art & Design practice daily', 'Follow fashion weeks: Lakme, Wills, global shows'], tip: 'Arts stream with Drawing/Fine Arts is ideal but not mandatory for NIFT' },
        { step: 3, title: 'NIFT / NID Entrance', icon: '📝', duration: 'January–March', type: 'exam', details: ['NIFT entrance: Written (GAT + CAT) + Studio Test + GD/PI', 'NID DAT: National Institute of Design entrance', 'Pearl Academy: Private design college in Delhi/Mumbai', 'Situation test: Make a product from given materials in 2 hours'], tip: 'NIFT Situation Test is unique — creativity + execution ability under time pressure' },
        { step: 4, title: 'B.Des Fashion Design (4 years)', icon: '🎓', duration: '4 years', type: 'education', details: ['Construction, Pattern Making, Textiles, Fashion Illustration, History of Fashion', 'Specialize: Garment Design, Accessory Design, Knitwear, Leather', 'Industry visits to textile mills, export houses', 'Final year project: Design and present your own collection'], tip: 'NIFT final year showcase is attended by industry bigwigs — your big break moment' },
        { step: 5, title: 'Internship / Own Label', icon: '🏢', duration: '6 months – 1 year', type: 'training', details: ['Intern at design houses: Rohit Bal, Ritu Kumar, Manish Malhotra', 'Retail internships at Zara, H&M, Lifestyle', 'Start own Instagram brand — e-commerce is accessible now'], tip: 'Many NIFT graduates launch their own label with Instagram/WhatsApp business first' },
        { step: 6, title: 'Career Growth', icon: '🚀', duration: 'Ongoing', type: 'growth', details: ['Designer → Senior Designer → Creative Director', 'Own Label → Brand → Fashion Week showcase', 'International: UAE, UK, USA fashion industry', 'Online: Myntra Design Studio, Amazon Fashion Design'], tip: 'Couture fashion takes 10 years to establish. Fast fashion/retail gives quicker ROI.' },
      ],
      entranceExams: [
        { name: 'NIFT Entrance', month: 'January', desc: 'National Institute of Fashion Technology (13 campuses)' },
        { name: 'NID DAT', month: 'January', desc: 'National Institute of Design entrance' },
        { name: 'UCEED', month: 'January', desc: 'IIT B.Des programmes' },
        { name: 'CEED', month: 'January', desc: 'IIT M.Des programmes' },
      ],
      topColleges: ['NIFT Delhi', 'NIFT Mumbai', 'NID Ahmedabad', 'Pearl Academy Delhi', 'IIT Bombay (IDC)', 'SNDT Mumbai', 'Raffles Design (Mumbai)'],
      careerGrowth: [
        { level: 'Entry (0–3 yrs)', role: 'Fashion Designer / Stylist Assistant', salary: '₹2.5L – ₹7L' },
        { level: 'Mid (4–7 yrs)', role: 'Senior Designer / Brand Designer', salary: '₹7L – ₹20L' },
        { level: 'Senior (8+ yrs)', role: 'Creative Director / Fashion Director', salary: '₹18L – ₹50L' },
        { level: 'Own Label', role: 'Independent Fashion Designer / Brand Owner', salary: '₹20L – ₹1Cr+' },
      ],
    },
  ],

  // ── B.Sc PURE SCIENCES & MATHEMATICS ─────────────────────────────────────────
  bsc: [
    {
      id: 'bsc-mathematics-teacher',
      title: 'B.Sc Mathematics → Teacher',
      tagline: 'Teach in government & private schools — stable, respected career',
      icon: '📐',
      gradient: 'from-emerald-600 to-teal-700',
      bgLight: 'bg-emerald-50',
      textColor: 'text-emerald-700',
      demand: 'Very High',
      avgSalary: '₹3L – ₹12L/year (Govt) | ₹2.5L – ₹8L/year (Private)',
      globalSalary: 'N/A (India-focused career)',
      duration: '3 yrs B.Sc + 2 yrs M.Sc (for PGT/UGC NET)',
      topRecruiters: ['KVS (Kendriya Vidyalaya Sangathan)', 'NVS (Navodaya Vidyalaya)', 'DSSSB', 'State Education Boards', 'CBSE Private Schools', 'Allen / FIITJEE / Byju\'s / Vedantu', 'IIT Coaching Institutes'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Score well in Maths — aim 85%+', 'Practice mental maths and reasoning', 'Develop strong fundamentals in Algebra & Geometry'],
          tip: 'Strong 10th Maths score is the foundation for B.Sc Maths admission at top colleges',
        },
        {
          step: 2, title: '11th–12th Science (PCM)', icon: '🔬',
          duration: '2 years', type: 'education',
          details: ['Choose Physics, Chemistry, Maths (PCM)', 'Score 60%+ for B.Sc Maths at good colleges', 'Study Calculus, Trigonometry, Coordinate Geometry', 'Practice NCERT thoroughly'],
          tip: 'Top colleges: Delhi University, BHU, Presidency College — CUET score needed',
        },
        {
          step: 3, title: 'B.Sc Mathematics (3 years)', icon: '🎓',
          duration: '3 years', type: 'education',
          details: ['Algebra, Analysis, Geometry, Statistics, Numerical Methods', 'Electives: Computer Maths, Operations Research', 'Appear in CUET for DU/BHU/central universities', 'Maintain 60%+ for M.Sc / B.Ed eligibility'],
          tip: 'DU B.Sc Maths Hons is one of the top programmes in India — highly competitive',
        },
        {
          step: 4, title: 'B.Ed OR M.Sc Maths', icon: '📝',
          duration: '1–2 years', type: 'education',
          details: ['B.Ed (1 year after graduation) → qualify for TGT (classes 6–10)', 'M.Sc Maths (2 years) → qualify for PGT (classes 11–12) and UGC NET', 'B.Ed entrance: DUET, state B.Ed CETs', 'M.Sc entrance: IIT JAM, CUET PG, BHU PET'],
          tip: 'M.Sc + B.Ed combo opens both PGT government schools and college lecturership',
        },
        {
          step: 5, title: 'CTET / State TET', icon: '📝',
          duration: 'Exam year-round', type: 'exam',
          details: ['CTET Paper 2 for classes 6–8 (TGT level)', 'State TET: UPTET, HTET, REET, MPTET, TNTET etc.', 'Must qualify TET to teach in any govt school', 'Validity: Lifetime (as per 2021 NEP revision)'],
          tip: 'CTET qualification is mandatory for KVS, NVS, and central govt school recruitment',
        },
        {
          step: 6, title: 'Government Teacher Recruitment', icon: '🏫',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'KVS TGT/PGT Maths — All India exam, 50,000+ posts',
            'NVS TGT/PGT — residential schools, good salary + accommodation',
            'DSSSB TGT Maths — Delhi schools, high competition',
            'State TRB/TET teacher recruitment in every state',
            'Salary: TGT ₹35,400–₹1,12,400 | PGT ₹47,600–₹1,51,100 (7th Pay)',
          ],
          tip: 'KVS PGT Maths salary with HRA + allowances reaches ₹80K–₹1L/month — govt school + benefits',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'TGT → Senior Teacher → Vice Principal → Principal',
            'UGC NET → College Lecturer (Assistant Professor) → Associate Professor',
            'PhD → Professor in Central/State University',
            'Private: Senior Faculty at Allen/FIITJEE → ₹8L–₹20L/year',
            'Online Teaching: Unacademy / Vedantu top educators earn ₹20L–₹1Cr/year',
          ],
          tip: 'Top online educators on Vedantu/Unacademy earn more than IIT professors — worth exploring',
        },
      ],
      entranceExams: [
        { name: 'CUET UG', month: 'May', desc: 'Central Universities B.Sc Maths admission (DU, BHU, JMI etc.)' },
        { name: 'IIT JAM', month: 'February', desc: 'M.Sc Maths at IITs — very prestigious' },
        { name: 'CTET', month: 'Jul & Dec', desc: 'Central Teacher Eligibility Test — mandatory for govt teaching' },
        { name: 'State TET', month: 'Varies by state', desc: 'UPTET, HTET, REET, MPTET, TNTET — state govt schools' },
        { name: 'KVS TGT/PGT', month: 'Aug–Sep', desc: 'Kendriya Vidyalaya teacher recruitment exam' },
        { name: 'NVS TGT/PGT', month: 'Mar–Apr', desc: 'Navodaya Vidyalaya teacher recruitment' },
        { name: 'UGC NET Maths', month: 'Jun & Dec', desc: 'College/university lecturership + JRF fellowship' },
      ],
      topColleges: ['Delhi University (Hons)', 'BHU Varanasi', 'Presidency College Kolkata', 'St. Xavier\'s Mumbai', 'Loyola College Chennai', 'Miranda House DU', 'IIT (for M.Sc via JAM)'],
      careerGrowth: [
        { level: 'TGT (0–5 yrs)', role: 'Trained Graduate Teacher (Class 6–10)', salary: '₹35,400–₹60,000/month (Govt) | ₹2.5L–₹5L (Private)' },
        { level: 'PGT (after M.Sc)', role: 'Post Graduate Teacher (Class 11–12)', salary: '₹47,600–₹80,000/month (Govt) | ₹4L–₹8L (Private)' },
        { level: 'Assistant Professor', role: 'UGC NET + College Lecturer', salary: '₹57,700–₹1.2L/month (Govt college)' },
        { level: 'Principal / Professor', role: 'School Principal / University Professor', salary: '₹1L–₹2L/month + perks' },
      ],
    },
    {
      id: 'bsc-science-teacher',
      title: 'B.Sc Science → Teacher',
      tagline: 'Teach Physics, Chemistry or Biology — govt & private schools nationwide',
      icon: '🔬',
      gradient: 'from-teal-600 to-cyan-700',
      bgLight: 'bg-teal-50',
      textColor: 'text-teal-700',
      demand: 'Very High',
      avgSalary: '₹3L – ₹12L/year (Govt) | ₹2.5L – ₹8L/year (Private)',
      globalSalary: 'N/A (India-focused career)',
      duration: '3 yrs B.Sc + B.Ed / M.Sc (2 yrs)',
      topRecruiters: ['KVS', 'NVS', 'DSSSB', 'State Education Boards', 'Army Public Schools', 'Kendriya Vidyalaya', 'DPS/Ryan/CBSE Private Schools', 'Coaching: Allen, Aakash, FIITJEE'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Score 70%+ in Science & Maths', 'Develop curiosity for Physics, Chemistry, or Biology', 'Lab work and experiments are key'],
          tip: 'Decide early: Physics/Maths (PCM) or Biology/Chemistry (PCB) — both lead to teaching',
        },
        {
          step: 2, title: '11th–12th Science (PCM or PCB)', icon: '🔬',
          duration: '2 years', type: 'education',
          details: ['PCM: Physics, Chemistry, Maths', 'PCB: Physics, Chemistry, Biology', 'Minimum 55–60% for B.Sc admission at good colleges', 'NCERT is your bible — master it'],
          tip: 'PCB students can also opt for B.Sc Botany, Zoology, Microbiology, or Biochemistry',
        },
        {
          step: 3, title: 'B.Sc (3 years)', icon: '🎓',
          duration: '3 years', type: 'education',
          details: [
            'B.Sc Physics / Chemistry / Biology / Botany / Zoology',
            'Choose one or two subjects as major',
            'CUET score for central university admissions',
            'Lab work, practicals, and project work are important',
          ],
          tip: 'B.Sc from Delhi University, BHU, Presidency Kolkata carry great value with employers',
        },
        {
          step: 4, title: 'B.Ed (1 year) or M.Sc (2 years)', icon: '📝',
          duration: '1–2 years', type: 'education',
          details: [
            'B.Ed: 1-year teacher training programme (mandatory for school teaching)',
            'M.Sc: Deepens subject expertise — required for PGT & college lecturer',
            'B.Ed + M.Sc → eligible for PGT and Assistant Professor',
            'B.Ed colleges: BHU, IGNOU, state B.Ed colleges, private B.Ed',
          ],
          tip: 'IGNOU B.Ed (2-year distance mode) is popular for working people',
        },
        {
          step: 5, title: 'CTET / State TET', icon: '📝',
          duration: 'Exam year-round', type: 'exam',
          details: [
            'CTET Paper 2: For classes 6–8 science & maths teacher',
            'CTET Paper 1: For classes 1–5 (primary) — needs B.El.Ed or B.Ed',
            'State TET: UPTET, HTET, REET, MPTET, TNTET, KTET, APTET etc.',
            'TET is mandatory for govt school employment nationwide',
          ],
          tip: 'TET validity is lifetime — qualifying once opens permanent govt teacher jobs',
        },
        {
          step: 6, title: 'Government School Recruitment', icon: '🏫',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'KVS TGT Science — All-India exam; posts in 1,200+ schools nationwide',
            'NVS TGT/PGT Science — residential Navodaya schools in every district',
            'Army Public School TGT/PGT — for defence area schools across India',
            'DSSSB TGT Science — Delhi govt schools',
            'State TRB: Every state has its own teacher recruitment board',
            'Salary: TGT ₹35,400 basic | PGT ₹47,600 basic + DA + HRA + allowances',
          ],
          tip: 'NVS teachers get free accommodation, food allowance — total package rivals private sector',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'TGT → Vice Principal → Principal (15–20 years)',
            'M.Sc + UGC NET → Assistant Professor → Associate Professor → Professor',
            'CSIR NET fellowship → Research at CSIR labs (₹31K–₹58K/month stipend)',
            'PhD → Research Scientist at ISRO, DRDO, BARC',
            'Private coaching: NEET/JEE faculty at Allen/Aakash earns ₹8L–₹25L/year',
            'Online educator (Unacademy/Vedantu NEET): top teachers earn ₹50L–₹1Cr+',
          ],
          tip: 'NEET coaching faculty is in extreme demand — top Allen/Aakash biology teachers earn over ₹20L/year',
        },
      ],
      entranceExams: [
        { name: 'CUET UG', month: 'May', desc: 'Central Universities B.Sc admission (DU, BHU, JNU etc.)' },
        { name: 'CTET', month: 'Jul & Dec', desc: 'Central Teacher Eligibility Test — mandatory for KVS/NVS/govt schools' },
        { name: 'State TET', month: 'Varies', desc: 'UPTET / HTET / REET / MPTET / TNTET — state boards' },
        { name: 'KVS TGT/PGT', month: 'Aug–Sep', desc: 'Kendriya Vidyalaya teacher exam' },
        { name: 'NVS TGT/PGT', month: 'Mar–Apr', desc: 'Navodaya Vidyalaya recruitment' },
        { name: 'CSIR UGC NET', month: 'Jun & Dec', desc: 'For college/university lecturership and JRF in sciences' },
        { name: 'IIT JAM', month: 'February', desc: 'M.Sc Physics/Chemistry/Biology at IITs' },
      ],
      topColleges: ['Delhi University', 'BHU Varanasi', 'Presidency College Kolkata', 'Fergusson College Pune', 'St. Xavier\'s Mumbai/Kolkata', 'Loyola College Chennai', 'Christ University Bangalore'],
      careerGrowth: [
        { level: 'TGT (0–5 yrs)', role: 'Science Teacher Class 6–10', salary: '₹35,400–₹60,000/month (Govt KVS/NVS)' },
        { level: 'PGT (after M.Sc)', role: 'Science Teacher Class 11–12', salary: '₹47,600–₹85,000/month + HRA + perks' },
        { level: 'Assistant Professor', role: 'UGC NET qualified college lecturer', salary: '₹57,700–₹1.2L/month' },
        { level: 'Research Scientist', role: 'CSIR / ISRO / DRDO Scientist', salary: '₹56,100–₹1.77L/month (govt scientist grade)' },
      ],
    },
    {
      id: 'bsc-mathematics-actuary',
      title: 'B.Sc Maths → Actuary / Data Analyst',
      tagline: 'Turn mathematics into high-paying finance and tech careers',
      icon: '📊',
      gradient: 'from-violet-600 to-emerald-600',
      bgLight: 'bg-violet-50',
      textColor: 'text-violet-700',
      demand: 'High',
      avgSalary: '₹5L – ₹40L/year',
      globalSalary: '$80K – $200K/year',
      duration: '3 yrs B.Sc + optional M.Sc / professional certification',
      topRecruiters: ['LIC', 'GIC Re', 'IRDAI', 'Max Life', 'HDFC Life', 'Accenture', 'Capgemini', 'Deloitte', 'JPMorgan', 'KPMG'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Excel in Maths — aim 90%+', 'Learn probability basics and statistics', 'Develop analytical thinking'],
          tip: 'Actuary is one of the highest-paid professions in India — strong Maths is the start',
        },
        {
          step: 2, title: '11th–12th PCM', icon: '🔬',
          duration: '2 years', type: 'education',
          details: ['Physics, Chemistry, Maths mandatory', 'Statistics as optional subject if available', 'Target 80%+ for top B.Sc colleges'],
          tip: 'Statistics optional in 12th is excellent preparation for actuarial science',
        },
        {
          step: 3, title: 'B.Sc Maths / Statistics', icon: '🎓',
          duration: '3 years', type: 'education',
          details: ['Probability, Statistics, Calculus, Linear Algebra, Financial Maths', 'Learn Python, R, Excel — parallel to degree', 'CUET for DU, BHU, ISI Kolkata', 'ISI Kolkata B.Stat is the most prestigious statistics degree in India'],
          tip: 'ISI Kolkata B.Stat → direct path to global data/actuary careers',
        },
        {
          step: 4, title: 'Actuarial Exams (IAI) or M.Sc', icon: '📝',
          duration: '3–7 years', type: 'exam',
          details: [
            'IAI (Institute of Actuaries of India) — 15 exam papers CT1–CT8 + CA + ST',
            'Each paper: 3 months prep, attempts from final year B.Sc onwards',
            'Alternatively: M.Sc Statistics / Data Science / Financial Maths',
            'IFoA (UK actuarial body) exams are internationally recognized',
          ],
          tip: 'Even 2–3 actuarial papers cleared + internship lands a ₹5L–₹8L job',
        },
        {
          step: 5, title: 'Internship / Analytics / Finance Job', icon: '🏢',
          duration: '6 months – 1 year', type: 'training',
          details: ['Actuarial analyst at insurance companies: LIC, GIC Re, Max Life', 'Data analyst at fintech firms, banks, consulting', 'Statistical analyst at research firms, MNCs', 'Apply on Naukri, LinkedIn — "actuarial analyst" / "data analyst" searches'],
          tip: 'A cleared CT3 paper + Python skills → immediate ₹4L–₹8L data analyst job',
        },
        {
          step: 6, title: 'Banking / UPSC Option', icon: '🏦',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'IBPS PO / SBI PO — bank probationary officer (Maths-heavy exam)',
            'RBI Grade B — research & policy roles (economics + maths)',
            'UPSC: Maths optional subject is one of the most scoring in IAS exam',
            'IRDAI (Insurance regulator) officer grade exam',
          ],
          tip: 'Maths optional in UPSC CSE is known for high scoring — many toppers use this strategy',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'Fellow Actuary (FIAI) → Chief Actuary of insurance companies (₹50L–₹2Cr)',
            'Data Science path: Analyst → Senior DS → Lead → Head of Analytics',
            'Quantitative Finance: Quant Analyst at hedge funds / global banks',
            'Research: PhD in Statistics / Applied Maths → academic career',
          ],
          tip: 'A fully qualified Fellow Actuary in India earns ₹50L–₹1.5Cr/year — among the highest in finance',
        },
      ],
      entranceExams: [
        { name: 'CUET UG', month: 'May', desc: 'DU, BHU, JNU B.Sc Maths/Statistics admission' },
        { name: 'ISI B.Stat', month: 'May', desc: 'Indian Statistical Institute — most prestigious stats degree' },
        { name: 'IAI CT exams', month: 'Year-round', desc: 'Actuarial professional exams (CT1–CT8)' },
        { name: 'IIT JAM', month: 'February', desc: 'M.Sc Maths/Statistics at IITs' },
        { name: 'IBPS PO / SBI PO', month: 'Oct–Nov', desc: 'Bank PO recruitment — Maths-heavy quantitative aptitude' },
        { name: 'RBI Grade B', month: 'June', desc: 'Reserve Bank of India officer — statistics & economics' },
      ],
      topColleges: ['ISI Kolkata (B.Stat)', 'Delhi University', 'BHU Varanasi', 'Presidency College Kolkata', 'IIT via JAM (M.Sc)', 'CMI Chennai', 'IGIDR Mumbai (PG Economics/Stats)'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Actuarial Analyst / Data Analyst', salary: '₹4L – ₹10L' },
        { level: 'Mid (3–6 yrs)', role: 'Senior Actuary / Analytics Manager', salary: '₹10L – ₹30L' },
        { level: 'Senior (7–12 yrs)', role: 'Appointed Actuary / Chief Analyst', salary: '₹30L – ₹80L' },
        { level: 'Fellow Actuary', role: 'FIAI / Chief Actuary', salary: '₹50L – ₹2Cr+' },
      ],
    },
    {
      id: 'bsc-science-research',
      title: 'B.Sc Science → Research Scientist',
      tagline: 'Work at ISRO, DRDO, CSIR, BARC — cutting-edge Indian science',
      icon: '🚀',
      gradient: 'from-blue-600 to-indigo-700',
      bgLight: 'bg-blue-50',
      textColor: 'text-blue-700',
      demand: 'Moderate — High',
      avgSalary: '₹4L – ₹20L/year (Govt research) | Higher in private R&D',
      globalSalary: '$60K – $150K/year (abroad)',
      duration: '3 yrs B.Sc + 2 yrs M.Sc + optional PhD',
      topRecruiters: ['ISRO', 'DRDO', 'BARC', 'CSIR (40+ labs)', 'DAE (Dept of Atomic Energy)', 'IIT Research Labs', 'Pharma R&D: Sun Pharma, Cipla, Dr. Reddy\'s'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Strong Science & Maths — aim 80%+', 'Participate in science olympiads (NSO, NTSE)', 'Read about scientists, research discoveries'],
          tip: 'NTSE scholarship in 10th is a feather in your cap — opens doors to DST funding later',
        },
        {
          step: 2, title: '11th–12th PCM or PCB', icon: '🔬',
          duration: '2 years', type: 'education',
          details: ['PCM → Physics / Chemistry / Maths B.Sc', 'PCB → Biology / Biotechnology / Microbiology', 'Target 70%+ for good university admissions', 'Science olympiad participation adds profile'],
          tip: 'KVPY scholarship (now INSPIRE) during 11–12th gives ₹5,000–₹7,000/month for research',
        },
        {
          step: 3, title: 'B.Sc (Honours) — 3 years', icon: '🎓',
          duration: '3 years', type: 'education',
          details: [
            'B.Sc Physics / Chemistry / Biology / Biochemistry / Microbiology',
            'Prestigious route: IISER (Indian Institute of Science Education & Research) — 5-year BS-MS',
            'CUET for DU, BHU, Presidency, St. Xavier\'s',
            'Maintain CGPA 7+ for M.Sc/research admissions',
          ],
          tip: 'IISER BS-MS (5 years) is the gold standard for research in India — better than IIT B.Sc route',
        },
        {
          step: 4, title: 'M.Sc + CSIR NET / GATE / JEST', icon: '📝',
          duration: '2 years + exam', type: 'exam',
          details: [
            'IIT JAM → M.Sc Physics/Chemistry/Biology at IITs (top route)',
            'CUET PG for central university M.Sc',
            'CSIR UGC NET → JRF (Junior Research Fellow) with ₹31,000/month stipend',
            'JEST → Physics/Theoretical CS research at TIFR, IIA, IUCAA',
            'GATE → Research positions in PSUs and IIT labs',
          ],
          tip: 'CSIR JRF gives ₹31,000/month stipend + HRA — fully funded PhD at top institutes',
        },
        {
          step: 5, title: 'Research / PhD / Govt Scientist', icon: '🔬',
          duration: '4–6 years (PhD)', type: 'training',
          details: [
            'PhD at IIT, IISc, IISER, TIFR, NCBS — fully funded with stipend',
            'DRDO entry: DRDO RAC (Recruitment and Assessment Centre) exam',
            'ISRO scientist entry: ISRO Centralised Recruitment Board exam (ICRB)',
            'BARC: DAE Graduate Fellowship Scheme — join as Trainee Scientific Officer',
          ],
          tip: 'ISRO/DRDO scientist posts have salary ₹56,100–₹1,77,500 (Scientific Officer grade)',
        },
        {
          step: 6, title: 'Industry R&D / Pharma / Tech', icon: '🏢',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'Pharma R&D: Sun Pharma, Cipla, Dr. Reddy\'s, Biocon — formulation/analytical chemists',
            'Food science: Nestle, ITC, Unilever research labs',
            'Biotech: GenomeIndia, Serum Institute, Bharat Biotech',
            'IT/AI: Science background increasingly valued at analytics companies',
          ],
          tip: 'PhD in Chemistry from IIT or IISc → pharma industry starting salary ₹8L–₹15L',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'Govt Scientist: Scientist-B → Scientist-G → Outstanding Scientist (top of scale)',
            'Postdoc → Professor at IIT/IISc/IISER (₹1L–₹2.5L/month)',
            'Abroad: Postdoc in USA/Europe ($50K–$60K) → Faculty / Industry',
            'Pharma: Scientist → Principal Scientist → R&D Director (₹30L–₹80L)',
          ],
          tip: 'DRDO/ISRO Scientists are eligible for DRDL/IITM residential campus perks + pension — great stability',
        },
      ],
      entranceExams: [
        { name: 'IISER Aptitude Test', month: 'June', desc: 'Indian Institutes of Science Education & Research — best for research' },
        { name: 'IIT JAM', month: 'February', desc: 'M.Sc Physics/Chemistry/Biology/Geology at IITs' },
        { name: 'CSIR UGC NET', month: 'Jun & Dec', desc: 'JRF fellowship + Lectureship in sciences' },
        { name: 'JEST', month: 'February', desc: 'Physics & Theoretical CS at TIFR, IIA, SNBNCBS' },
        { name: 'GATE', month: 'February', desc: 'PSU research jobs and IIT PhD admissions' },
        { name: 'DRDO RAC', month: 'Oct–Nov', desc: 'DRDO Scientist B recruitment exam' },
        { name: 'ISRO ICRB', month: 'Varies', desc: 'ISRO Scientist/Engineer recruitment' },
      ],
      topColleges: ['IISc Bangalore', 'IISER (6 campuses)', 'IITs (via JAM M.Sc)', 'TIFR Mumbai', 'Presidency College Kolkata', 'BHU Varanasi', 'St. Xavier\'s Kolkata / Mumbai'],
      careerGrowth: [
        { level: 'Junior Scientist (0–5 yrs)', role: 'Scientist-B / JRF / Research Associate', salary: '₹31,000–₹56,000/month (stipend + salary)' },
        { level: 'Mid (5–10 yrs)', role: 'Scientist-C/D / Asst Professor', salary: '₹67,700–₹1,17,000/month' },
        { level: 'Senior (10–20 yrs)', role: 'Scientist-E/F / Associate Professor', salary: '₹1,17,000–₹1,77,500/month' },
        { level: 'Distinguished (20+ yrs)', role: 'Outstanding Scientist / Professor / R&D Head', salary: '₹1.5L–₹2.5L/month + perks' },
      ],
    },

    // ── B.Sc COMPUTER SCIENCE ─────────────────────────────────────────────────
    {
      id: 'bsc-computer-science',
      title: 'B.Sc Computer Science',
      tagline: 'Tech career without JEE — software, govt IT, teaching & MCA',
      icon: '💻',
      gradient: 'from-sky-600 to-indigo-700',
      bgLight: 'bg-sky-50',
      textColor: 'text-sky-700',
      demand: 'Very High',
      avgSalary: '₹3.5L – ₹30L/year',
      globalSalary: '$60K – $150K/year',
      duration: '3 years B.Sc + optional MCA / M.Sc CS (2 yrs)',
      programmingLanguages: ['Python', 'Java', 'C / C++', 'JavaScript', 'SQL'],
      mustKnow: ['Data Structures & Algorithms', 'DBMS', 'Operating Systems', 'Web basics (HTML/CSS)', 'Git & GitHub'],
      topRecruiters: ['TCS', 'Infosys', 'Wipro', 'HCL', 'Accenture', 'Cognizant', 'Tech Mahindra', 'NIC (Govt IT)', 'CDAC', 'KVS / NVS (Teaching)'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Score well in Maths & Science — aim 70%+', 'Start basic programming curiosity (Python, Scratch)', 'Practice logical reasoning and problem-solving'],
          tip: 'B.Sc CS is a great tech route if JEE is not your plan — equally valued by IT companies',
        },
        {
          step: 2, title: '11th–12th PCM / PCMCs', icon: '🔬',
          duration: '2 years', type: 'education',
          details: ['Choose PCM or PCM + Computer Science as subjects', 'Computer Science in 11th–12th gives direct advantage', 'Target 55%+ for most B.Sc CS colleges; 70%+ for top ones', 'Practice C / Python basics from NCERT CS textbook'],
          tip: 'CBSE 11th–12th Computer Science NCERT is excellent — builds real coding foundation',
        },
        {
          step: 3, title: 'B.Sc Computer Science (3 years)', icon: '🎓',
          duration: '3 years', type: 'education',
          details: [
            'Core subjects: DSA, DBMS, OS, Computer Networks, Software Engineering',
            'Languages studied: C, C++, Java, Python, SQL',
            'Admission: CUET for DU/central universities; state CETs for others',
            'Build projects: web apps, mini software tools, GitHub portfolio',
            'Internships from 2nd year — Internshala, LinkedIn, AngelList',
          ],
          tip: 'Delhi University B.Sc CS (Hons) is one of the most respected non-engineering CS degrees in India',
        },
        {
          step: 4, title: 'MCA or M.Sc CS (optional but recommended)', icon: '📝',
          duration: '2 years', type: 'education',
          details: [
            'MCA (Master of Computer Applications) — gateway to higher software roles',
            'NIMCET → NIT MCA (most prestigious MCA in India)',
            'M.Sc CS / M.Sc AI — available at DU, BHU, BITS, Hyderabad University',
            'GATE CS → M.Tech at IIT/NIT (extremely prestigious, changes salary band)',
            'MCA + placement: TCS, Infosys, Wipro actively hire MCA graduates',
          ],
          tip: 'GATE CS → M.Tech IIT is a game-changer — salary jumps from ₹4L to ₹18L–₹40L',
        },
        {
          step: 5, title: 'Government IT Jobs', icon: '🏛️',
          duration: 'Exam-based', type: 'exam',
          details: [
            'NIC (National Informatics Centre) — Scientist B: central govt IT backbone',
            'CDAC (Centre for Development of Advanced Computing) — IT research & products',
            'SSC CGL Tier I/II + Computer proficiency test — central govt offices',
            'IBPS SO IT Officer — IT specialist officer in public sector banks',
            'DRDO / ISRO / BARC — Junior Research Fellow (CS/IT branch)',
            'State IT departments: STQC, state NIC offices, e-governance projects',
          ],
          tip: 'NIC Scientist B salary starts at ₹56,100/month + HRA + DA — excellent govt IT career',
        },
        {
          step: 6, title: 'CS Teacher — Govt & Private', icon: '🏫',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'CTET Paper 2 + B.Ed → TGT Computer Science in CBSE govt schools',
            'KVS TGT Computer Science — 1,200+ Kendriya Vidyalayas nationwide',
            'NVS TGT Computer Science — residential Navodaya schools',
            'State TRB exams: TGT / PGT Computer Science in every state',
            'Private: CBSE / ICSE school CS teacher (₹3L–₹8L/year)',
            'Coaching: Java / Python faculty at NIIT, Aptech, coding bootcamps',
          ],
          tip: 'KVS TGT Computer Science salary with allowances reaches ₹55K–₹80K/month — stable + pension',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'Software path: Junior Developer → Senior → Tech Lead → Architect (₹6L–₹50L+)',
            'Govt IT: NIC Scientist B → C → D → E (₹56K–₹1.77L/month)',
            'Teaching: TGT → Vice Principal → Principal; UGC NET → Lecturer',
            'MCA/GATE + IIT M.Tech → ₹20L–₹60L placements at product companies',
            'Freelance: Web / app development on Upwork, Fiverr — unlimited earning',
            'Startup: B.Sc CS grads increasingly founding SaaS / edtech startups',
          ],
          tip: 'B.Sc CS + GATE + IIT M.Tech is the most underrated path to top-tier tech salaries without JEE',
        },
      ],
      entranceExams: [
        { name: 'CUET UG', month: 'May', desc: 'DU, BHU, JNU B.Sc CS / B.Sc IT admission' },
        { name: 'GATE CS', month: 'February', desc: 'M.Tech CS at IITs/NITs — massive salary boost' },
        { name: 'NIMCET', month: 'June', desc: 'NIT MCA — top MCA programme in India' },
        { name: 'CTET', month: 'Jul & Dec', desc: 'Mandatory for KVS/NVS TGT Computer Science' },
        { name: 'KVS TGT CS', month: 'Aug–Sep', desc: 'Kendriya Vidyalaya teacher recruitment' },
        { name: 'NIC Scientist B', month: 'Varies', desc: 'National Informatics Centre govt IT jobs' },
        { name: 'IBPS SO IT', month: 'Nov', desc: 'IT Officer in public sector banks' },
      ],
      topColleges: ['Delhi University (B.Sc CS Hons)', 'BHU Varanasi', 'Jamia Millia Islamia', 'Hyderabad University', 'Christ University Bangalore', 'Presidency College Kolkata', 'NIT (via NIMCET for MCA)'],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Junior Developer / Software Trainee', salary: '₹3.5L – ₹8L' },
        { level: 'Mid (3–5 yrs)', role: 'Software Developer / MCA-level Engineer', salary: '₹8L – ₹20L' },
        { level: 'Senior (6–10 yrs)', role: 'Senior Developer / Tech Lead / Govt IT Officer', salary: '₹18L – ₹45L (pvt) | ₹80K–₹1.2L/month (govt)' },
        { level: 'IIT M.Tech (via GATE)', role: 'Product Engineer at top companies', salary: '₹20L – ₹60L+' },
      ],
    },

    // ── B.Sc NURSING ─────────────────────────────────────────────────────────
    {
      id: 'bsc-nursing',
      title: 'B.Sc Nursing',
      tagline: 'Govt hospitals, corporate ICUs, abroad placements & nursing education',
      icon: '🏥',
      gradient: 'from-rose-500 to-pink-700',
      bgLight: 'bg-rose-50',
      textColor: 'text-rose-700',
      demand: 'Extremely High',
      avgSalary: '₹3L – ₹12L/year (India) | ₹25L – ₹60L/year (Abroad)',
      globalSalary: '$55K – $110K/year (USA/UK/Canada/Australia)',
      duration: '4 years B.Sc Nursing + 6 months internship',
      topRecruiters: ['AIIMS', 'PGIMER', 'JIPMER', 'Apollo Hospitals', 'Fortis', 'Max Healthcare', 'Manipal Hospitals', 'Armed Forces Medical Services', 'NHS UK', 'US Hospitals (NCLEX route)'],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: ['Score 60%+ in Science — Biology is the key subject', 'Develop empathy, communication, and people skills', 'Understand basic anatomy and first-aid from NCERT'],
          tip: 'Nursing is one of the most in-demand healthcare careers globally — strong 10th Biology is the start',
        },
        {
          step: 2, title: '11th–12th PCB', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'Physics, Chemistry, Biology (PCB) mandatory',
            'Score 45%+ for general category (40% for reserved) in 12th PCB',
            'English proficiency is critical — must score 45%+ in English too',
            'NCERT Biology chapters on human physiology are exam-critical',
          ],
          tip: 'AIIMS B.Sc Nursing needs 50%+ in PCB; most state nursing colleges accept 45%',
        },
        {
          step: 3, title: 'B.Sc Nursing Entrance & Admission', icon: '📝',
          duration: 'May–July', type: 'exam',
          details: [
            'NEET UG score accepted at AIIMS, BHU, JIPMER, PGIMER for B.Sc Nursing',
            'AIIMS B.Sc Nursing: Separate entrance exam (BSc Nursing entrance)',
            'State nursing entrance: RUHS Nursing, MH Nursing CET, UP Nursing entrances',
            'Private nursing colleges: Management quota admissions available',
            'Duration: 4 years degree + 6 months mandatory internship',
          ],
          tip: 'Government B.Sc Nursing seats are very limited — apply to both central and state colleges',
        },
        {
          step: 4, title: 'B.Sc Nursing (4 years)', icon: '🎓',
          duration: '4 years + 6 months internship', type: 'education',
          details: [
            'Anatomy, Physiology, Biochemistry, Microbiology, Pharmacology',
            'Medical-Surgical Nursing, Paediatric Nursing, Obstetric & Gynae Nursing',
            'Community Health Nursing, Mental Health Nursing, ICU & Critical Care basics',
            'Mandatory clinical rotations at hospital wards, OT, ICU, emergency',
            'Register with State Nursing Council after completing degree',
          ],
          tip: 'Strong clinical rotations in ICU, OT, and emergency give the best job placement edge',
        },
        {
          step: 5, title: 'Government Nursing Jobs', icon: '🏛️',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'AIIMS Staff Nurse: One of the best govt nursing jobs — ₹44,900–₹1,42,400/month',
            'ESIC Staff Nurse — Employees State Insurance hospitals across India',
            'Railway Nursing Superintendent — RRB recruitment, stable govt career',
            'Armed Forces (Army Nursing Corps / Navy / Air Force) — commissioned officer',
            'State Govt hospitals: State PSC / health recruitment board exams',
            'NIMHANS, PGIMER, JIPMER — central institute staff nurse posts',
          ],
          tip: 'Army Nursing Corps gives commissioned officer rank — salary + accommodation + pension + prestige',
        },
        {
          step: 6, title: 'International Nursing (UK / USA / Canada / Gulf)', icon: '✈️',
          duration: '1–2 years prep', type: 'training',
          details: [
            'USA: NCLEX-RN exam → US nursing licence → $75,000–$110,000/year',
            'UK: NMC (Nursing & Midwifery Council) registration → NHS jobs → £30,000–₹55,000/year',
            'Canada: NCLEX-RN + provincial registration → CAD 70,000–90,000/year',
            'Australia: AHPRA registration → AUD 65,000–85,000/year',
            'Gulf (UAE/Saudi/Kuwait/Qatar): Direct hospital recruitment — tax-free salary ₹25L–₹45L equivalent',
            'OET (Occupational English Test) required for UK/Australia/NZ routes',
          ],
          tip: 'NCLEX-RN coaching is available in India for ₹80K–₹1.5L — ROI is ₹60L+/year salary in USA',
        },
        {
          step: 7, title: 'Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'Staff Nurse → Senior Nurse → Nursing Supervisor → Chief Nursing Officer',
            'M.Sc Nursing (2 years) → Nursing lecturer / clinical specialist',
            'M.Sc Nursing + NET → Assistant Professor at nursing college (₹57,700+/month)',
            'ICU / OT / Emergency specialization → higher pay in private hospitals',
            'Nurse Practitioner (with M.Sc) → semi-diagnostic roles in rural / NHUM settings',
            'Abroad: Lead Nurse / Charge Nurse → Nursing Manager → Director of Nursing',
          ],
          tip: 'M.Sc Nursing from AIIMS or PGIMER + teaching career is the highest status path in Indian nursing',
        },
      ],
      entranceExams: [
        { name: 'NEET UG', month: 'May', desc: 'Required for AIIMS / BHU / JIPMER B.Sc Nursing admission' },
        { name: 'AIIMS B.Sc Nursing', month: 'June', desc: 'AIIMS-specific nursing entrance exam' },
        { name: 'PGIMER Nursing', month: 'May', desc: 'PGIMER Chandigarh B.Sc Nursing entrance' },
        { name: 'State Nursing CET', month: 'Jun–Jul', desc: 'State-level: RUHS, MH Nursing, UP Nursing CETs' },
        { name: 'NCLEX-RN', month: 'Year-round', desc: 'US nursing licence — gateway to $75K–$110K jobs in USA' },
        { name: 'NMC Registration', month: 'Year-round', desc: 'UK Nursing & Midwifery Council — NHS jobs' },
        { name: 'OET Nursing', month: 'Year-round', desc: 'English test required for UK/Australia/NZ nursing registration' },
      ],
      topColleges: ['AIIMS Delhi (B.Sc Nursing)', 'PGIMER Chandigarh', 'JIPMER Puducherry', 'NIMHANS Bangalore', 'AFMC Pune (Army)', 'CMC Vellore', 'Manipal College of Nursing', 'MAHE Manipal'],
      careerGrowth: [
        { level: 'Staff Nurse (0–3 yrs)', role: 'Staff Nurse — Govt hospital / Corporate hospital', salary: '₹3L–₹6L (private) | ₹44,900/month+ (AIIMS govt)' },
        { level: 'Senior Nurse (4–8 yrs)', role: 'Senior Nurse / ICU Specialist / Charge Nurse', salary: '₹6L–₹15L (India) | ₹25L–₹45L (Gulf)' },
        { level: 'International (NCLEX/NMC)', role: 'Registered Nurse — USA / UK / Canada / Australia', salary: '₹40L–₹80L equivalent/year' },
        { level: 'M.Sc Nursing + Teaching', role: 'Nursing Lecturer / Clinical Specialist / Chief Nurse', salary: '₹57,700–₹1.5L/month (teaching) | ₹20L–₹40L (pvt)' },
      ],
    },

    // ── B.Sc AGRICULTURE ─────────────────────────────────────────────────────
    {
      id: 'bsc-agriculture',
      title: 'B.Sc Agriculture',
      tagline: 'Govt officer, bank AFO, agri-tech, research, teaching & farming business',
      icon: '🌾',
      gradient: 'from-green-600 to-lime-700',
      bgLight: 'bg-green-50',
      textColor: 'text-green-700',
      demand: 'Very High',
      avgSalary: '₹3L – ₹18L/year (India) | ₹30L–₹80L (abroad / agri-tech)',
      globalSalary: '$50K – $120K/year (USA/Canada/Australia/FAO)',
      duration: '4 years B.Sc Agriculture + optional M.Sc (2 yrs)',
      topRecruiters: [
        'ICAR (Indian Council of Agricultural Research)',
        'NABARD', 'FCI (Food Corporation of India)',
        'State Agriculture Departments', 'Bayer CropScience',
        'Syngenta', 'UPL Ltd', 'Coromandel International',
        'ITC Agri Business', 'DeHaat', 'Ninjacart', 'AgroStar',
      ],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: [
            'Score well in Science & Maths — aim 60%+',
            'Learn about crops, soil, weather from NCERT environmental science',
            'Participate in school science fairs with agriculture topics',
          ],
          tip: 'B.Sc Agriculture opens more govt job doors than most people realise — ADO, AFO, NABARD, FCI, ICAR',
        },
        {
          step: 2, title: '11th–12th PCB or PCM', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'PCB (Physics, Chemistry, Biology) is the standard route for B.Sc Agriculture',
            'PCM students are also eligible at most agricultural universities',
            'Minimum 50% in 10+2 with Science for ICAR AIEEA admission',
            'Biology and Chemistry are the most relevant — study NCERT thoroughly',
          ],
          tip: 'ICAR AIEEA is the national entrance for top agriculture universities — start preparing in 12th',
        },
        {
          step: 3, title: 'B.Sc Agriculture — Entrance & Admission', icon: '📝',
          duration: 'April–July', type: 'exam',
          details: [
            'ICAR AIEEA UG: All-India entrance for IARI, SAUs (State Agricultural Universities)',
            'State agriculture entrances: KEAM (Kerala), MH CET, Rajasthan JET, MP PAT',
            'PAU (Punjab Agricultural University) — own entrance',
            'TNAU (Tamil Nadu Agricultural University) — own CET',
            'Duration: 4 years; subjects include Agronomy, Horticulture, Soil Science, Plant Pathology',
          ],
          tip: 'IARI New Delhi and PAU Ludhiana are the two most prestigious agriculture colleges in India',
        },
        {
          step: 4, title: 'B.Sc Agriculture (4 years)', icon: '🎓',
          duration: '4 years', type: 'education',
          details: [
            'Agronomy, Soil Science, Plant Breeding & Genetics, Agricultural Economics',
            'Horticulture, Plant Pathology, Agricultural Entomology, Farm Machinery',
            'Irrigation & Water Management, Post-Harvest Technology, Extension Education',
            'Rural Agricultural Work Experience (RAWE) — compulsory village attachment',
            'Internship at FCI, seed companies, agri-input firms, ICAR labs',
          ],
          tip: 'RAWE programme and internships at ICAR labs add huge value — treat them seriously',
        },
        {
          step: 5, title: 'Government Jobs — Officer Level', icon: '🏛️',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'Agricultural Development Officer (ADO) / Agriculture Officer — State PSC: every state recruits',
            'FCI (Food Corporation of India) — Agri Graduate: procurement, storage, distribution of food grains',
            'UPSC IFS (Indian Forest Service) — Agriculture optional + prelims + mains',
            'UPSC IAS — Agriculture & Animal Husbandry optional (scoring optional)',
            'State Agriculture Department — Extension Officer, Field Inspector, Horticulture Officer',
            'IARI Technician / Research Associate — ICAR national research labs',
            'Salary: State ADO ₹35,400–₹1,12,400; FCI AGM ₹40,000–₹1,40,000/month',
          ],
          tip: 'State ADO / Agriculture Officer posts are recruited every year in bulk — very accessible with B.Sc Agri',
        },
        {
          step: 6, title: 'Banking — NABARD & IBPS AFO', icon: '🏦',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'IBPS AFO (Agriculture Field Officer) — Specialist Officer in all public sector banks',
            'NABARD Grade A Development Assistant (Agriculture stream) — most prestigious agri banking role',
            'NABARD Grade B Manager — policy, rural development, research roles',
            'SBI Agriculture Specialist Officer — rural lending, Kisan Credit Card schemes',
            'RBI Grade B (with agriculture economics background)',
            'State Cooperative Banks — District Central Cooperative Bank (DCCB) officer',
            'Salary: IBPS AFO ₹36,000–₹63,840/month; NABARD Grade A ₹44,500/month base',
          ],
          tip: 'NABARD Grade A is one of the best govt banking jobs in India — agri graduates have a dedicated stream',
        },
        {
          step: 7, title: 'Research — M.Sc & ICAR JRF', icon: '🔬',
          duration: '2+ years', type: 'education',
          details: [
            'ICAR AIEEA PG: M.Sc Agriculture at IARI, PAU, TNAU, BAU, AAU — all top SAUs',
            'ICAR JRF (Junior Research Fellowship) — ₹31,000/month stipend + research at ICAR labs',
            'M.Sc specialisations: Plant Breeding, Soil Science, Agronomy, Agricultural Economics',
            'PhD after M.Sc → ICAR Scientist, university professor',
            'IARI New Delhi PhD is equivalent to IIT PhD in agriculture — top placement',
          ],
          tip: 'ICAR JRF stipend of ₹31,000/month + fully funded M.Sc/PhD — best research funding for agri students',
        },
        {
          step: 8, title: 'Agri-Tech, Food Industry & Private Sector', icon: '💼',
          duration: 'Ongoing', type: 'training',
          details: [
            'Agri-input companies: Bayer CropScience, Syngenta, UPL, PI Industries, Coromandel — sales, R&D, field officer',
            'Seed companies: Mahyco, Nuziveedu, Advanta — plant breeder, product specialist',
            'Food processing: ITC Agri, Nestle, Dabur, Britannia, PepsiCo — quality, procurement, R&D',
            'Agri-tech startups: DeHaat, Ninjacart, AgroStar, BigHaat, Jivabhumi — field operations, tech roles',
            'Fertilizer companies: IFFCO, NFL, Chambal Fertilizers — agri advisor, sales',
            'Commodity trading: MCX, NCDEX — agri commodity analyst',
          ],
          tip: 'Agri-tech startups are hiring agri graduates with ₹5L–₹15L packages — best growth sector in agri',
        },
        {
          step: 9, title: 'Teaching, Entrepreneurship & International', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'UGC NET Agriculture → Assistant Professor at agriculture college (₹57,700+/month)',
            'KVS / NVS / State TRB — Agriculture teacher in govt schools (after B.Ed)',
            'Own farming business: Organic farming, contract farming, poly house horticulture',
            'Agri export: Fruits, vegetables, spices — APEDA registered exporter',
            'Abroad: MS in Agriculture/Food Science in USA/Australia/Canada; FAO (UN) jobs',
            'Agri consultancy: Advise farmers, input companies, government schemes',
          ],
          tip: 'Organic farming + export is extremely lucrative — certified organic produce commands 3–5x premium price',
        },
      ],
      entranceExams: [
        { name: 'ICAR AIEEA UG', month: 'June', desc: 'National entrance for B.Sc Agriculture at IARI & all SAUs' },
        { name: 'ICAR AIEEA PG', month: 'June', desc: 'M.Sc Agriculture at IARI, PAU, TNAU and all major SAUs' },
        { name: 'ICAR JRF', month: 'June', desc: 'Junior Research Fellowship — ₹31,000/month stipend for research' },
        { name: 'IBPS AFO', month: 'Oct–Nov', desc: 'Agriculture Field Officer in all public sector banks' },
        { name: 'NABARD Grade A', month: 'Mar–Apr', desc: 'Development Assistant Agriculture — premier agri banking role' },
        { name: 'FCI Agri Graduate', month: 'Varies', desc: 'Food Corporation of India recruitment for agri graduates' },
        { name: 'State PSC Agri Officer', month: 'Varies', desc: 'ADO / Agriculture Officer — every state recruits separately' },
        { name: 'UGC NET Agriculture', month: 'Jun & Dec', desc: 'College lecturership in agriculture' },
        { name: 'UPSC IFS', month: 'Jun', desc: 'Indian Forest Service — with Agriculture/Botany optional' },
      ],
      topColleges: [
        'IARI New Delhi (Deemed University)',
        'PAU Ludhiana (Punjab Agricultural University)',
        'TNAU Coimbatore',
        'BHU Varanasi (Institute of Agricultural Sciences)',
        'ANGRAU Guntur',
        'GBPUAT Pantnagar (G.B. Pant Agri & Tech University)',
        'UAS Dharwad / Bengaluru',
        'BAU Sabour (Bihar Agricultural University)',
      ],
      careerGrowth: [
        { level: 'Entry (0–3 yrs)', role: 'ADO / AFO / Field Officer / Agri Sales Executive', salary: '₹3L–₹8L (private) | ₹35,400/month+ (govt ADO)' },
        { level: 'Mid (4–8 yrs)', role: 'Senior Agriculture Officer / NABARD / FCI Manager', salary: '₹8L–₹20L (pvt) | ₹44,500–₹70,000/month (NABARD/FCI)' },
        { level: 'Research / Scientist', role: 'ICAR Scientist / University Professor', salary: '₹57,700–₹1,82,400/month (govt scientist grade)' },
        { level: 'Senior Govt / Abroad', role: 'District Agriculture Officer / MS abroad / FAO expert', salary: '₹1L–₹2L/month (sr govt) | $60K–$120K (abroad)' },
      ],
    },

    // ── B.Sc BIOTECHNOLOGY ───────────────────────────────────────────────────
    {
      id: 'bsc-biotechnology',
      title: 'B.Sc Biotechnology',
      tagline: 'Pharma R&D, biotech startups, CSIR/DBT research, bioinformatics & abroad',
      icon: '🧬',
      gradient: 'from-purple-600 to-fuchsia-700',
      bgLight: 'bg-purple-50',
      textColor: 'text-purple-700',
      demand: 'High',
      avgSalary: '₹3L – ₹20L/year (India) | ₹40L–₹1Cr+ (abroad/research)',
      globalSalary: '$60K – $130K/year (USA/Germany/UK)',
      duration: '3 years B.Sc + optional M.Sc (2 yrs) / M.Tech Biotech',
      topRecruiters: [
        'Biocon', 'Dr. Reddy\'s Labs', 'Sun Pharma', 'Cipla', 'Serum Institute',
        'Bharat Biotech', 'Pfizer India', 'Abbott', 'CSIR Labs (40+)',
        'DBT (Dept of Biotechnology)', 'ICMR', 'NCBS Bangalore', 'IIT Research Labs',
        'Syngene International', 'Anthem Biosciences',
      ],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: [
            'Score 70%+ in Science — Biology and Chemistry are most important',
            'Develop curiosity about DNA, genetics, medicine, and living systems',
            'Read about CRISPR, vaccines, genetic diseases — builds early passion',
          ],
          tip: 'Biotechnology is the science of the 21st century — it drives vaccines, cancer drugs, and gene therapy',
        },
        {
          step: 2, title: '11th–12th PCB or PCMB', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'PCB (Physics, Chemistry, Biology) is the standard route',
            'PCMB (all four) gives extra options like B.Tech Biotech via JEE',
            'Score 55%+ for most B.Sc Biotech colleges; 70%+ for top DU/BHU colleges',
            'Study NCERT Biology Class 11–12 deeply — Genetics, Biotechnology chapters are directly tested',
          ],
          tip: 'NCERT Class 12 Biology Chapter 12 (Biotechnology — Principles & Processes) is exam-critical for CUET',
        },
        {
          step: 3, title: 'B.Sc Biotechnology — Admission', icon: '📝',
          duration: 'May–July', type: 'exam',
          details: [
            'CUET UG → DU (B.Sc Hons Biological Sciences / Biochemistry / Biotechnology), BHU, JMI',
            'JNUEE → JNU B.Sc Biotechnology (one of the most respected)',
            'State university direct merit admissions',
            'Private colleges: Amity, Manipal, UPES, Christ University — management quota',
            'Duration: 3 years; for B.Tech Biotech (4 years) — JEE/state CET applies',
          ],
          tip: 'JNU and DU are the most prestigious for B.Sc Biotech — focus on CUET Biology + Chemistry',
        },
        {
          step: 4, title: 'B.Sc Biotechnology (3 years)', icon: '🎓',
          duration: '3 years', type: 'education',
          details: [
            'Cell Biology, Microbiology, Genetics, Biochemistry, Molecular Biology',
            'Immunology, Genetic Engineering, Bioinformatics, Bioprocess Technology',
            'Industrial Biotechnology, Environmental Biotechnology, Plant Biotechnology',
            'Lab skills: PCR, gel electrophoresis, cell culture, ELISA, HPLC — essential for jobs',
            'Mini-projects, dissertation, and summer research internships from 2nd year',
          ],
          tip: 'Hands-on lab skills (PCR, cell culture, ELISA) matter more than theory for industry hiring',
        },
        {
          step: 5, title: 'M.Sc / M.Tech Biotechnology', icon: '🎓',
          duration: '2 years', type: 'education',
          details: [
            'IIT JAM Biotechnology (BT) → M.Sc Biotech at IITs — best for research/industry',
            'IIT JAM Life Sciences → IIT M.Sc Life Science / Biochemistry',
            'JNUEE PG → JNU M.Sc Biotechnology (top research environment)',
            'CUET PG → BHU, Hyderabad University, Delhi University M.Sc Biotech',
            'M.Tech Biotechnology: GATE BT → NIT/IIT M.Tech — leads to ₹12L–₹25L industry jobs',
            'Specialise: Medical Biotech, Industrial Biotech, Bioinformatics, Agricultural Biotech',
          ],
          tip: 'IIT Bombay / Delhi M.Sc Biotech via JAM → industry placements at ₹8L–₹18L — worth every bit of prep',
        },
        {
          step: 6, title: 'Research — CSIR, DBT, ICMR, NCBS', icon: '🔬',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'CSIR UGC NET Life Sciences → JRF ₹31,000/month + PhD at CSIR labs (CCMB, IGIB, NII, CDRI)',
            'DBT JRF (Dept of Biotechnology) → ₹31,000/month stipend at IISc, IITs, NCBS',
            'ICMR JRF → ₹31,000/month research in medical/health sciences',
            'NCBS Bangalore (TIFR centre) — world-class cell biology and genetics research',
            'NIBMG (National Institute of Biomedical Genomics) — genomics research',
            'InStem Bangalore — Stem cell and regenerative biology research',
          ],
          tip: 'CSIR / DBT JRF is fully funded — stipend + HRA + research at India\'s best science institutes',
        },
        {
          step: 7, title: 'Pharma & Biotech Industry', icon: '💊',
          duration: 'Ongoing', type: 'training',
          details: [
            'Biocon — biologics, biosimilars, insulin; top biotech employer in India',
            'Serum Institute of India — vaccines; world\'s largest vaccine manufacturer',
            'Bharat Biotech — Covaxin, Rotavac; innovative vaccine R&D',
            'Dr. Reddy\'s, Sun Pharma, Cipla — QC, R&D, regulatory affairs roles',
            'Clinical Research Organisations (CROs): IQVIA, PRA Health, Quintiles — clinical trial management',
            'Medical devices: Siemens Healthineers, BD Biosciences, Thermo Fisher India',
            'Agri-biotech: Mahyco, BASF Crop Science, Bayer BioScience — plant biotech, seed R&D',
          ],
          tip: 'Regulatory affairs roles at pharma companies are very well-paid and growing fast — worth specialising in',
        },
        {
          step: 8, title: 'Bioinformatics, Data & Government', icon: '💻',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'Bioinformatics: Genome sequencing analysis, drug discovery AI, protein modelling',
            'Skills needed: Python, R, BLAST, PyMOL, AutoDock, Linux — learn alongside degree',
            'DBT (Dept of Biotechnology, Govt of India) — Programme Officer, Scientist roles',
            'BIRAC (Biotechnology Industry Research Assistance Council) — govt funding body',
            'CSIR labs — 40+ labs across India: CCMB Hyderabad, IGIB Delhi, NCL Pune, CDRI Lucknow',
            'ICMR (Indian Council of Medical Research) — public health, disease research',
          ],
          tip: 'Bioinformatics + Python skills can get you a ₹6L–₹20L job even with just M.Sc — niche but very in-demand',
        },
        {
          step: 9, title: 'International, Teaching & Startups', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'PhD abroad: USA (NIH funded), Germany (DAAD funded), UK, Canada — stipend $25K–$40K/year',
            'Postdoc → Faculty at US/European university (full career abroad)',
            'UGC NET Biotechnology → Assistant Professor at college (₹57,700/month)',
            'Biotech startup: Diagnostics kits, agri biotech products, personalised medicine — BIRAC funds startups',
            'BIRAC BIG Grant: ₹50L grant for early-stage biotech startups',
            'Intellectual Property (patent filing) — IP analyst / patent agent roles growing fast',
          ],
          tip: 'BIRAC BIG grant of ₹50L is available for B.Sc/M.Sc Biotech graduates with a startup idea — apply early',
        },
      ],
      entranceExams: [
        { name: 'CUET UG', month: 'May', desc: 'DU, BHU, JMI B.Sc Biotechnology / Biological Sciences' },
        { name: 'JNUEE', month: 'May', desc: 'JNU B.Sc Biotechnology — top research-oriented programme' },
        { name: 'IIT JAM BT', month: 'February', desc: 'M.Sc Biotechnology at IITs — industry & research gateway' },
        { name: 'GATE Biotech (BT)', month: 'February', desc: 'M.Tech Biotech at NITs/IITs + PSU research jobs' },
        { name: 'CSIR UGC NET LS', month: 'Jun & Dec', desc: 'JRF ₹31K/month for PhD at CSIR labs + lectureship' },
        { name: 'DBT JRF', month: 'September', desc: 'Dept of Biotechnology JRF — ₹31K/month research stipend' },
        { name: 'ICMR JRF', month: 'July', desc: 'Medical research fellowship at ICMR institutes' },
        { name: 'UGC NET Biotech', month: 'Jun & Dec', desc: 'College/university lecturer eligibility' },
      ],
      topColleges: [
        'JNU New Delhi (JNUEE)', 'Delhi University (B.Sc Hons)', 'BHU Varanasi',
        'Hyderabad University', 'IIT (via JAM M.Sc)', 'NCBS Bangalore (PhD/research)',
        'Amity University (private)', 'Manipal University', 'Christ University Bangalore',
      ],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'Lab Analyst / QC Executive / Research Trainee', salary: '₹3L – ₹7L' },
        { level: 'Mid (3–6 yrs)', role: 'Senior Research Associate / Pharma Scientist', salary: '₹7L – ₹20L' },
        { level: 'Research (PhD path)', role: 'CSIR/DBT Scientist / IIT Professor', salary: '₹57,700–₹2L/month' },
        { level: 'International / Senior', role: 'Research Scientist abroad / Biotech Startup Founder', salary: '$70K–$130K/year | ₹30L–₹1Cr+ (startup)' },
      ],
    },

    // ── BPT — BACHELOR OF PHYSIOTHERAPY ──────────────────────────────────────
    {
      id: 'bpt-physiotherapy',
      title: 'BPT — Bachelor of Physiotherapy',
      tagline: 'Hospitals, sports teams, neuro rehab, own clinic & international healthcare',
      icon: '🦴',
      gradient: 'from-orange-500 to-red-600',
      bgLight: 'bg-orange-50',
      textColor: 'text-orange-700',
      demand: 'Very High',
      avgSalary: '₹3L – ₹15L/year (India) | ₹30L–₹80L/year (abroad)',
      globalSalary: '$55K – $100K/year (USA/UK/Canada/Australia)',
      duration: '4.5 years (4 years degree + 6 months mandatory internship)',
      topRecruiters: [
        'AIIMS', 'PGIMER', 'Apollo Hospitals', 'Fortis Healthcare', 'Max Healthcare',
        'Manipal Hospitals', 'Medanta', 'Armed Forces Medical Services',
        'BCCI (cricket team physio)', 'Indian Olympic teams', 'NHS UK',
        'Australian hospitals (AHPRA route)', 'Own Clinic / Home Care',
      ],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: [
            'Score 60%+ in Science — Biology and Physics are key',
            'Learn about human anatomy, muscles, joints from basic NCERT',
            'Develop interest in sports science, rehabilitation, and patient care',
          ],
          tip: 'BPT is a 4.5-year allied health degree — as respected as nursing in the healthcare system',
        },
        {
          step: 2, title: '11th–12th PCB', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'Physics, Chemistry, Biology (PCB) is mandatory for BPT admission',
            'Minimum 50% in PCB aggregate for most colleges; some require 45%',
            'English 50%+ required — communication with patients is critical',
            'Study NCERT Biology: Locomotion & Movement, Neural Control chapters carefully',
          ],
          tip: 'No NEET needed for most BPT colleges — state CET or merit-based; NEET score is a bonus at top colleges',
        },
        {
          step: 3, title: 'BPT Entrance & Admission', icon: '📝',
          duration: 'May–July', type: 'exam',
          details: [
            'AIIMS BPT: Separate entrance exam — most prestigious BPT seat in India',
            'State CETs: IPU CET (Delhi), Maharashtra NEET-linked, Karnataka CET, KEAM',
            'Many states use Class 12 PCB merit for govt BPT college admission',
            'Private BPT colleges: Management quota available with 45–50% PCB',
            'Duration: 4 years of coursework + 6 months compulsory rotational internship',
          ],
          tip: 'AIIMS and PGIMER BPT are the most coveted seats — limited, competitive, but career-defining',
        },
        {
          step: 4, title: 'BPT Degree — 4.5 Years', icon: '🎓',
          duration: '4 years + 6 months internship', type: 'education',
          details: [
            'Year 1: Anatomy, Physiology, Biochemistry, Psychology, Sociology',
            'Year 2: Pathology, Microbiology, Pharmacology, Exercise Therapy, Electrotherapy',
            'Year 3: Orthopedic PT, Neurological PT, Cardio-Pulmonary PT, Sports PT basics',
            'Year 4: Pediatric PT, Geriatric PT, Community Rehab, Sports & Wellness',
            'Internship rotations: Orthopedics, Neurology, ICU, Sports, Pediatrics, Community',
            'Register with State Physiotherapy Council / IAP after degree',
          ],
          tip: 'ICU physiotherapy and neurological rehabilitation are highest-paying specialisations — master them during internship',
        },
        {
          step: 5, title: 'Government Hospital & Institutional Jobs', icon: '🏛️',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'AIIMS Staff Physiotherapist — ₹44,900–₹1,42,400/month (best govt physio job)',
            'PGIMER, JIPMER, NIMHANS — central institute physiotherapist posts',
            'ESIC — Employees State Insurance hospitals physiotherapist recruitment',
            'Railways (RRB) — Physiotherapist posts in railway hospitals across India',
            'Armed Forces: Army / Navy / Air Force physiotherapist (commissioned officer grade)',
            'State PSC Physiotherapist: Every state health department recruits separately',
            'CGHS (Central Govt Health Scheme) empanelled physiotherapist',
          ],
          tip: 'Army physiotherapist is a commissioned officer — salary + accommodation + pension + service prestige',
        },
        {
          step: 6, title: 'Corporate Hospitals & Specialisations', icon: '🏥',
          duration: 'Ongoing', type: 'training',
          details: [
            'Apollo, Fortis, Max, Manipal, Medanta — inpatient + outpatient physiotherapy',
            'Orthopedic rehab: Post-surgery (hip/knee replacement, ACL repair) — highest volume',
            'Neurological rehab: Stroke rehab, Parkinson\'s, spinal cord injury — complex, well-paid',
            'Cardio-pulmonary: ICU physio, post-cardiac surgery breathing rehab — very specialised',
            'Paediatric PT: Cerebral palsy, developmental delay, autism rehab — growing demand',
            'Geriatric PT: Elderly fall prevention, Alzheimer\'s mobility — rapidly expanding field',
          ],
          tip: 'Neurological and ICU physiotherapy command the highest salaries in private hospitals (₹8L–₹18L)',
        },
        {
          step: 7, title: 'Sports Physiotherapy', icon: '⚽',
          duration: 'Ongoing', type: 'training',
          details: [
            'IPL teams, ISL football, Pro Kabaddi League — each franchise has a physio on staff',
            'Board of Control for Cricket in India (BCCI) — team physiotherapist',
            'Sports Authority of India (SAI) — National Training Centre physiotherapist (govt job)',
            'Olympic / Commonwealth / Asian Games — attached to national sports federations',
            'State sports academies — Rajasthan, UP, Haryana, Maharashtra sports physio',
            'Private sports clubs, gyms, fitness centres, corporate wellness — growing sector',
          ],
          tip: 'IPL team physiotherapist travels internationally — ₹12L–₹30L/year + all expenses paid',
        },
        {
          step: 8, title: 'MPT + Teaching + Research', icon: '📚',
          duration: '2 years MPT', type: 'education',
          details: [
            'MPT (Master of Physiotherapy) — 2 years post-BPT specialisation',
            'Specialisations: Ortho & Sports, Neuro, Cardio-Pulmonary, Paediatrics, Musculoskeletal',
            'MPT entrance: NIMHANS, AIIMS MPT, IPU CET PG, state PG physio entrance',
            'MPT + PhD → Physiotherapy college professor / HOD',
            'UGC NET — eligible after MPT for teaching posts in physiotherapy colleges',
            'Research: Clinical trials, evidence-based physiotherapy, outcome measures — growing in India',
          ],
          tip: 'MPT from NIMHANS or AIIMS is the most respected postgraduate physiotherapy in India',
        },
        {
          step: 9, title: 'Own Clinic, Home Care & International', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'Own clinic after 2–3 years experience: Home care physiotherapy is booming post-COVID',
            'Doorstep physio: ₹800–₹2,000 per session; 8–10 sessions/day = ₹80K–₹2L/month',
            'Telerehabilitation — online physio consultations expanding rapidly',
            'UK: HCPC (Health & Care Professions Council) registration → NHS physiotherapist → £35,000–£50,000/year',
            'Australia: AHPRA registration → AUD 65,000–85,000/year',
            'Canada: College of Physiotherapists provincial registration → CAD 70,000–90,000/year',
            'UAE / Gulf: DHA (Dubai Health Authority) or MOH registration → tax-free ₹25L–₹45L equivalent',
          ],
          tip: 'Home care physiotherapy in Indian metros charges ₹1,000–₹2,500/session — starting your own practice is the highest-earning path',
        },
      ],
      entranceExams: [
        { name: 'AIIMS BPT Entrance', month: 'June', desc: 'AIIMS-specific BPT entrance — most prestigious BPT seat' },
        { name: 'IPU CET BPT', month: 'May', desc: 'Guru Gobind Singh IP University — Delhi BPT admissions' },
        { name: 'State BPT CET', month: 'Jun–Jul', desc: 'Maharashtra, Karnataka, Kerala, UP state BPT admissions' },
        { name: 'NEET UG', month: 'May', desc: 'Required at some states/colleges for BPT eligibility' },
        { name: 'AIIMS MPT', month: 'June', desc: 'AIIMS postgraduate physiotherapy entrance' },
        { name: 'NIMHANS MPT', month: 'May', desc: 'National Institute of Mental Health — top neuro physio PG' },
        { name: 'UK HCPC', month: 'Year-round', desc: 'UK physiotherapy licence — NHS jobs £35K–£50K/year' },
        { name: 'AHPRA (Australia)', month: 'Year-round', desc: 'Australian physio registration — AUD 65K–85K/year' },
      ],
      topColleges: [
        'AIIMS New Delhi', 'PGIMER Chandigarh', 'NIMHANS Bangalore',
        'JIPMER Puducherry', 'Manipal College of Allied Health Sciences',
        'CMC Vellore', 'Amrita School of Allied Health Sciences',
        'MGM Institute of Physiotherapy Aurangabad', 'IPU affiliated colleges (Delhi)',
      ],
      careerGrowth: [
        { level: 'Fresher (0–2 yrs)', role: 'Junior Physiotherapist — hospital / clinic', salary: '₹2.5L–₹6L (private) | ₹44,900/month (AIIMS)' },
        { level: 'Mid (3–6 yrs)', role: 'Senior Physiotherapist / Sports Physio / Specialist', salary: '₹6L–₹15L (India) | ₹25L–₹45L (Gulf)' },
        { level: 'Own Practice / Sports', role: 'Own clinic / IPL team physio / Home care', salary: '₹12L–₹40L+/year' },
        { level: 'International', role: 'NHS UK / Australia / Canada physiotherapist', salary: '₹30L–₹80L equivalent/year' },
      ],
    },

    // ── B.Pharm / B.Sc PHARMACY ───────────────────────────────────────────────
    {
      id: 'bpharm-pharmacy',
      title: 'B.Pharm — Bachelor of Pharmacy',
      tagline: 'Drug inspector, pharma industry, clinical research, NIPER & abroad',
      icon: '💊',
      gradient: 'from-cyan-600 to-blue-700',
      bgLight: 'bg-cyan-50',
      textColor: 'text-cyan-700',
      demand: 'Very High',
      avgSalary: '₹3L – ₹20L/year (India) | ₹40L–₹90L/year (abroad)',
      globalSalary: '$70K – $130K/year (USA/UK/Canada/Australia)',
      duration: '4 years B.Pharm + optional M.Pharm (2 yrs) or Pharm.D (6 yrs)',
      topRecruiters: [
        'Sun Pharma', 'Dr. Reddy\'s Labs', 'Cipla', 'Lupin', 'Aurobindo Pharma',
        'Zydus Lifesciences', 'Biocon', 'Alkem', 'IPCA Labs', 'Mankind Pharma',
        'CDSCO (Central Drugs Standard Control Organisation)', 'ESIC', 'RRB (Railways)',
        'NIPER Hyderabad/Ahmedabad/Mohali', 'WHO India Office',
      ],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: [
            'Score 60%+ in Science — Chemistry and Biology are most critical',
            'Understand basics of medicines, how drugs work on the body',
            'India is the world\'s pharmacy to developing nations — huge career scope',
          ],
          tip: 'India manufactures 20% of the world\'s generic medicines — B.Pharm graduates are always in demand globally',
        },
        {
          step: 2, title: '11th–12th PCB or PCM', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'PCB or PCM both accepted for B.Pharm admission',
            'Minimum 50% in Physics, Chemistry, and Biology/Maths in Class 12',
            'NEET score accepted at some pharmacy colleges for lateral entry / D.Pharm',
            'Chemistry — Organic Chemistry (reactions, mechanisms) is the backbone of pharmacy',
          ],
          tip: 'Strong Organic Chemistry in 12th directly helps with Medicinal Chemistry and Drug Design in B.Pharm',
        },
        {
          step: 3, title: 'B.Pharm Entrance & Admission', icon: '📝',
          duration: 'April–July', type: 'exam',
          details: [
            'GPAT is the national PG entrance — start awareness from B.Pharm 1st year',
            'State pharmacy CETs: MH CET Pharmacy, UPCET, KCET, KEAM, WBJEE (pharmacy)',
            'BITS Pilani B.Pharm — via BITSAT (one of the best private B.Pharm)',
            'Manipal, MAHE, Amrita, JSS — top private pharmacy colleges',
            'Duration: 4 years; Pharm.D is 6 years (clinical pharmacy focus)',
          ],
          tip: 'BITS Pilani B.Pharm is among the best in India — good campus placements at pharma MNCs',
        },
        {
          step: 4, title: 'B.Pharm — 4 Years', icon: '🎓',
          duration: '4 years', type: 'education',
          details: [
            'Pharmaceutics, Pharmacology, Medicinal Chemistry, Pharmaceutical Analysis',
            'Pharmacognosy (herbal/natural drugs), Biochemistry, Microbiology',
            'Industrial Pharmacy, Hospital & Clinical Pharmacy, Regulatory Affairs basics',
            'Practical: Formulation labs, analytical instrument training (HPLC, UV, IR)',
            'Internship at hospital pharmacy, pharma company, or community pharmacy',
            'Register with State Pharmacy Council after graduation',
          ],
          tip: 'HPLC, UV spectroscopy, and formulation lab skills are directly hired by QC departments at day one',
        },
        {
          step: 5, title: 'Pharma Industry — All Departments', icon: '🏭',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'QA/QC: Quality Assurance & Quality Control — largest hiring area; ₹3L–₹12L entry',
            'Formulation R&D: Tablet, capsule, injection, ointment development — ₹4L–₹20L',
            'Regulatory Affairs: CDSCO/USFDA/EMA submissions, drug dossier preparation — ₹5L–₹25L',
            'Medical Representative (MR): Pharma sales to doctors — quick entry, ₹3L–₹8L + incentives',
            'Production/Manufacturing: GMP compliance, batch processing — stable core department',
            'Pharmacovigilance: Drug safety monitoring — growing field, remote-friendly, ₹4L–₹15L',
          ],
          tip: 'Regulatory Affairs and Pharmacovigilance are the fastest-growing, highest-paying specialisations in pharma right now',
        },
        {
          step: 6, title: 'Government Jobs — Drug Inspector & More', icon: '🏛️',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'Drug Inspector (State PSC) — inspect pharma manufacturers and retail chemists; Group B/C gazetted',
            'Central Drug Standard Control Organisation (CDSCO) — Drug Inspector Central (Group B)',
            'ESIC Pharmacist — Employees State Insurance hospitals; ₹44,900–₹1,42,400/month',
            'RRB Pharmacist (Indian Railways) — hospital pharmacist in railway hospitals',
            'Army/Navy/Air Force Pharmacist — commissioned JCO; ₹35K–₹70K/month + perks',
            'CGHS Pharmacist — Central Government Health Scheme pharmacies across India',
            'State Health Department Pharmacist — PSC-recruited, permanent govt job with pension',
          ],
          tip: 'State Drug Inspector exam is not as competitive as other govt exams — good odds with focused 6-month preparation',
        },
        {
          step: 7, title: 'M.Pharm at NIPER — India\'s Top PG', icon: '📝',
          duration: '2 years', type: 'education',
          details: [
            'GPAT (Graduate Pharmacy Aptitude Test) — national M.Pharm entrance; 200 marks',
            'NIPER JEE → NIH-equivalent for pharmacy in India; 7 NIPERs across India',
            'NIPER Hyderabad, Mohali, Ahmedabad, Raebareli, Kolkata, Guwahati, Hajipur',
            'NIPER M.Pharm specialisations: Drug Delivery, Medicinal Chemistry, Pharmaceutical Analysis',
            'NIPER placements: Pfizer, Novartis, AstraZeneca, J&J — ₹8L–₹20L packages',
          ],
          tip: 'NIPER is to pharmacy what IIT is to engineering — GPAT + NIPER JEE preparation from Year 3 is ideal',
        },
        {
          step: 8, title: 'Clinical Research & Hospital Pharmacy', icon: '🏥',
          duration: 'Ongoing', type: 'training',
          details: [
            'Clinical Research Organisations (CROs): IQVIA, Parexel, Syneos Health, ICON plc — trial management',
            'Clinical Research Associate (CRA) — monitors drug trials at hospitals; ₹5L–₹18L',
            'Hospital Clinical Pharmacist — medication review, drug therapy optimization — ₹4L–₹12L',
            'Community Pharmacy — own medical shop after pharmacist registration; ₹3L–₹15L net',
            'USFDA Consulting — help Indian companies get ANDA approvals in USA — high demand',
          ],
          tip: 'Owning a community pharmacy (medical shop) in a tier-2 city after 3–5 years experience can net ₹8L–₹25L/year',
        },
        {
          step: 9, title: 'International, PhD & Career Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'USA: FPGEE (Foreign Pharmacy Graduate Equivalency Exam) → US pharmacist licence → $110,000–$140,000/year',
            'UK: GPhC (General Pharmaceutical Council) registration → NHS pharmacist → £40,000–£65,000/year',
            'Australia: AHPRA + KAPS exam → AUD 70,000–100,000/year',
            'Canada: PEBC (Pharmacy Examining Board of Canada) → CAD 80,000–110,000/year',
            'PhD at IIT/NIPER/foreign university — academic research career, ₹1L–₹2L/month India',
            'Career path India: MR → Product Manager → Brand Manager → Marketing Head (₹25L–₹1Cr)',
          ],
          tip: 'US pharmacist licence (FPGEE + NAPLEX) earns $130,000–$140,000/year — one of the best ROI paths from B.Pharm',
        },
      ],
      entranceExams: [
        { name: 'GPAT', month: 'February', desc: 'Graduate Pharmacy Aptitude Test — gateway to M.Pharm at NITs & NIPER JEE' },
        { name: 'NIPER JEE', month: 'June', desc: 'National Institute of Pharmaceutical Education and Research — India\'s best pharma PG' },
        { name: 'State Pharmacy CET', month: 'May–Jun', desc: 'MH CET Pharmacy, UPCET, KCET, KEAM, WBJEE (Pharmacy)' },
        { name: 'BITSAT (B.Pharm)', month: 'May', desc: 'BITS Pilani B.Pharm — top private pharmacy' },
        { name: 'Drug Inspector (PSC)', month: 'Varies', desc: 'State PSC Drug Inspector exam — gazetted govt officer' },
        { name: 'ESIC Pharmacist', month: 'Varies', desc: 'Employees State Insurance pharmacist posts' },
        { name: 'RRB Pharmacist', month: 'Varies', desc: 'Railway Recruitment Board pharmacist' },
        { name: 'FPGEE (USA)', month: 'Year-round', desc: 'Foreign Pharmacy Graduate Equivalency — USA pharmacist licence' },
      ],
      topColleges: [
        'NIPER Hyderabad (best pharma PG)', 'NIPER Mohali', 'NIPER Ahmedabad',
        'BITS Pilani (B.Pharm)', 'Manipal College of Pharmaceutical Sciences',
        'JSS College of Pharmacy Ooty/Mysore', 'Amrita School of Pharmacy',
        'Bombay College of Pharmacy', 'IIIM Jammu (CSIR)', 'Panjab University Chandigarh',
      ],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'QC Analyst / MR / Hospital Pharmacist', salary: '₹3L–₹7L' },
        { level: 'Mid (3–6 yrs)', role: 'Senior Formulation Scientist / Regulatory Affairs Executive', salary: '₹7L–₹20L' },
        { level: 'NIPER / M.Pharm Specialist', role: 'Drug Delivery Scientist / Clinical Research Manager', salary: '₹10L–₹30L' },
        { level: 'International', role: 'US/UK/Australia Licensed Pharmacist', salary: '₹50L–₹1Cr+ equivalent' },
      ],
    },

    // ── B.Sc FORESTRY ────────────────────────────────────────────────────────
    {
      id: 'bsc-forestry',
      title: 'B.Sc Forestry',
      tagline: 'IFS officer, forest ranger, wildlife research, eco-tourism & climate careers',
      icon: '🌲',
      gradient: 'from-green-700 to-emerald-800',
      bgLight: 'bg-green-50',
      textColor: 'text-green-800',
      demand: 'Moderate — High',
      avgSalary: '₹3L – ₹15L/year (India) | ₹30L–₹70L (international)',
      globalSalary: '$50K – $100K/year (FAO, UNEP, international conservation orgs)',
      duration: '4 years B.Sc Hons Forestry',
      topRecruiters: [
        'Ministry of Environment, Forest & Climate Change (MoEFCC)',
        'Forest Survey of India (FSI)', 'Wildlife Institute of India (WII)',
        'ICFRE (Indian Council of Forestry Research)', 'ISRO (Land Use / Remote Sensing)',
        'State Forest Departments', 'WWF India', 'WCS India', 'IUCN',
        'FAO (Food & Agriculture Organization)', 'GIZ Germany', 'Carbon credit firms',
      ],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: [
            'Score 60%+ in Science — Biology, Geography, and Environment chapters are key',
            'Develop interest in wildlife, ecology, climate change, and outdoor environments',
            'Join NSS, NCC, nature clubs — field mindset is essential for forestry',
          ],
          tip: 'Forestry is a hidden gem — IFS (Indian Forest Service) is a Class I gazetted officer, as prestigious as IAS/IPS',
        },
        {
          step: 2, title: '11th–12th PCB or PCM', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'PCB preferred — Biology, Ecology, Environmental Science chapters matter most',
            'PCM also accepted at many forestry colleges',
            'Minimum 50% PCB/PCM for B.Sc Forestry admissions',
            'NCERT Geography: Vegetation and Forest chapters + Environment chapters from Biology',
          ],
          tip: 'Reading about India\'s national parks, tiger reserves, and biodiversity hotspots builds genuine advantage in interviews',
        },
        {
          step: 3, title: 'B.Sc Forestry Entrance & Admission', icon: '📝',
          duration: 'May–July', type: 'exam',
          details: [
            'FRI Dehradun (Forest Research Institute) — separate entrance exam; most prestigious forestry college',
            'ICAR AIEEA — for B.Sc Forestry at Agricultural Universities (GBPUAT, TNAU, UAS)',
            'State forestry entrances: Rajasthan JET, MP PAT, Kerala Forestry CET',
            'Dr. Y.S. Parmar University Solan (Himachal Pradesh) — top dedicated forestry university',
            'Kerala Agricultural University, Assam Agricultural University — forestry departments',
          ],
          tip: 'FRI Dehradun B.Sc Forestry is the most prestigious — alumni dominate IFS, FSI, WII positions',
        },
        {
          step: 4, title: 'B.Sc Forestry — 4 Years', icon: '🎓',
          duration: '4 years', type: 'education',
          details: [
            'Silviculture (growing and managing forests), Forest Management, Forest Protection',
            'Tree Physiology, Dendrology (tree identification), Soil Science, Watershed Management',
            'Wildlife Management, Remote Sensing & GIS for forestry, Forest Economics',
            'Environmental Law, Forest Policy, Social Forestry, Agroforestry',
            'Field camps: mandatory forest camping, tree surveys, wildlife transects',
            'Internship at State Forest Department, FRI, WII, national parks',
          ],
          tip: 'GIS and Remote Sensing skills learned in B.Sc Forestry are directly used at FSI, ISRO, and climate consulting firms',
        },
        {
          step: 5, title: 'UPSC — Indian Forest Service (IFS)', icon: '🏛️',
          duration: '1–2 years prep', type: 'exam',
          details: [
            'IFS (Indian Forest Service) — Group A gazetted, equivalent to IAS/IPS prestige',
            'Exam: UPSC Civil Services Prelims → IFS Mains (6 papers: Forestry + optional)',
            'Forestry is the main technical paper — B.Sc Forestry gives direct advantage',
            'IFS officer manages entire forest divisions — wildlife, timber, conservation, tribal welfare',
            'Salary: IFS officer starts at ₹56,100 + forest allowance + accommodation in forest bungalow',
            'Career: ACF → DCF → CF → CCF → PCCF (Principal Chief Conservator of Forests)',
          ],
          tip: 'IFS officers live in forest bungalows, manage national parks, protect wildlife — most fulfilling govt career in India',
        },
        {
          step: 6, title: 'State Forest Services — Forest Ranger', icon: '🌿',
          duration: 'Exam-based', type: 'milestone',
          details: [
            'State Forest Service (SFS) Exam — Group B gazetted; every state recruits separately',
            'Forest Ranger: Manages a forest range (800–3,000 sq km), supervises Beat Officers',
            'Deputy Ranger → Ranger → Divisional Forest Officer (DFO via promotion)',
            'Forest Beat Officer / Forest Guard (Group C) — entry without SFS; recruitment via SSC/state',
            'Forest Development Corporation (FDC) — state-level timber and NTFP (Non-Timber Forest Products) management',
            'Salary: Forest Ranger ₹35,400–₹1,12,400/month; Forest Guard ₹18,000–₹30,000/month',
          ],
          tip: 'State Forest Ranger posts are filled every 2–3 years in large numbers — far less competitive than IFS',
        },
        {
          step: 7, title: 'Research — FRI, WII, ICFRE, ISRO', icon: '🔬',
          duration: 'Ongoing', type: 'training',
          details: [
            'FRI Dehradun (Forest Research Institute) — research on timber, silviculture, forest diseases',
            'Wildlife Institute of India (WII) Dehradun — wildlife census, tiger monitoring, camera trap surveys',
            'ICFRE (Indian Council of Forestry Research & Education) — 8 research institutes across India',
            'Forest Survey of India (FSI) — bi-annual State of Forest Report, carbon stock assessment',
            'ISRO NRSC — satellite-based forest cover mapping, land degradation monitoring',
            'ICAR CAFRI Jhansi — agroforestry research (Central Agroforestry Research Institute)',
          ],
          tip: 'WII wildlife biologist positions are dream jobs — work on Project Tiger, Project Elephant, snow leopard conservation',
        },
        {
          step: 8, title: 'Climate, NGOs & International Careers', icon: '🌍',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'Carbon credits / REDD+ projects — forest carbon sequestration consulting; booming post-Paris Agreement',
            'WWF India, WCS India, NCF (Nature Conservation Foundation), CES Bangalore — wildlife research',
            'FAO (Food & Agriculture Organization) — Forest Officer positions in Rome/regional offices',
            'IUFRO (International Union of Forest Research Organizations) — global forest research network',
            'GIZ Germany, USAID — funded forest conservation and rural livelihood projects',
            'UNEP (UN Environment Programme) — climate and biodiversity programme officers',
            'Green consulting: Environmental Impact Assessment (EIA) consultant — ₹6L–₹20L private sector',
          ],
          tip: 'Carbon credit consulting and EIA consulting are the highest-paying private sector paths for forestry graduates',
        },
        {
          step: 9, title: 'Teaching, Eco-tourism & Startups', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'M.Sc Forestry / Environmental Science → UGC NET → Lecturer at agriculture/forestry college',
            'Eco-tourism: Set up forest homestays, wildlife safari consulting, birding tour operations',
            'Bamboo/medicinal plants cultivation — profitable agro-forestry enterprise',
            'NTFP (Non-Timber Forest Products) value chain: honey, lac, tendu, mahua — entrepreneurship',
            'PhD in Forestry → IFS / FRI / WII research scientist / professor',
            'Forest App Development: Tree identification apps, biodiversity databases — tech-forestry startups',
          ],
          tip: 'Eco-tourism near tiger reserves (Ranthambore, Corbett, Bandhavgarh) is a ₹500Cr+ industry — great entrepreneurship scope',
        },
      ],
      entranceExams: [
        { name: 'FRI Entrance (Dehradun)', month: 'May', desc: 'Forest Research Institute B.Sc Forestry — most prestigious' },
        { name: 'ICAR AIEEA', month: 'June', desc: 'B.Sc Forestry at GBPUAT, TNAU, UAS — state agri university route' },
        { name: 'State Forestry CET', month: 'Jun–Jul', desc: 'Rajasthan JET, MP PAT, Kerala, Himachal — state forestry colleges' },
        { name: 'UPSC IFS', month: 'Jun (with CSP)', desc: 'Indian Forest Service — Group A gazetted Class I officer' },
        { name: 'State Forest Service Exam', month: 'Varies', desc: 'Forest Ranger (Group B) — every state recruits separately' },
        { name: 'SSC Forest Guard', month: 'Varies', desc: 'Forest Guard / Beat Officer — Group C entry-level' },
        { name: 'ICFRE JRF', month: 'Varies', desc: 'ICFRE research fellowship — forest research institutes' },
        { name: 'UGC NET Env. Sciences', month: 'Jun & Dec', desc: 'College lecturership in environmental/forest sciences' },
      ],
      topColleges: [
        'FRI Dehradun (Forest Research Institute) — No. 1',
        'Dr. Y.S. Parmar University Solan (Himachal Pradesh)',
        'GBPUAT Pantnagar (Uttarakhand)',
        'Kerala Agricultural University',
        'TNAU Coimbatore',
        'Assam Agricultural University Jorhat',
        'UAS Bengaluru / Dharwad',
        'Rajendra Agricultural University Pusa (Bihar)',
      ],
      careerGrowth: [
        { level: 'Forest Guard / Beat Officer', role: 'Group C — state forest dept', salary: '₹18,000–₹30,000/month' },
        { level: 'Forest Ranger (SFS)', role: 'Group B gazetted — state forest service', salary: '₹35,400–₹60,000/month' },
        { level: 'IFS Officer (UPSC)', role: 'ACF → DCF → CF — Class I gazetted', salary: '₹56,100–₹2,25,000/month' },
        { level: 'Research / International', role: 'WII / FRI Scientist / FAO Officer / Carbon Consultant', salary: '₹8L–₹25L (India) | ₹40L–₹80L (international)' },
      ],
    },

    // ── B.Sc MICROBIOLOGY ────────────────────────────────────────────────────
    {
      id: 'bsc-microbiology',
      title: 'B.Sc Microbiology',
      tagline: 'Pharma QC, food safety, clinical labs, CSIR/ICMR research & abroad',
      icon: '🦠',
      gradient: 'from-indigo-600 to-purple-700',
      bgLight: 'bg-indigo-50',
      textColor: 'text-indigo-700',
      demand: 'High',
      avgSalary: '₹3L – ₹18L/year (India) | ₹35L–₹80L (abroad)',
      globalSalary: '$55K – $110K/year (USA/UK/Canada)',
      duration: '3 years B.Sc + optional M.Sc (2 yrs)',
      topRecruiters: [
        'Sun Pharma', 'Cipla', 'Biocon', 'Serum Institute', 'Bharat Biotech',
        'SRL Diagnostics', 'Metropolis Healthcare', 'Dr. Lal PathLabs',
        'Nestle India', 'Amul (GCMMF)', 'ITC Foods', 'FSSAI',
        'CSIR-IMTECH Chandigarh', 'ICMR', 'NIV Pune', 'NCDC Delhi',
      ],
      roadmap: [
        {
          step: 1, title: '10th Grade', icon: '📚',
          duration: '2 years', type: 'education',
          details: [
            'Score 65%+ in Science — Biology and Chemistry are most critical',
            'Learn about bacteria, viruses, fungi from NCERT Class 8–10 Science',
            'COVID-19 showed the world how critical microbiologists are — a future-proof career',
          ],
          tip: 'Microbiologists were at the frontline of COVID vaccine development — Serum Institute, Bharat Biotech were led by microbiologists',
        },
        {
          step: 2, title: '11th–12th PCB', icon: '🔬',
          duration: '2 years', type: 'education',
          details: [
            'PCB (Physics, Chemistry, Biology) — Biology is the most important',
            'Score 50%+ in PCB aggregate for most colleges; 65%+ for top DU/BHU',
            'NCERT Class 12 Biology: Microbes in Human Welfare chapter — directly tested',
            'Basic chemistry (organic reactions) is important for Microbiology lab work',
          ],
          tip: 'NCERT Class 12 Biology Chapter 16 (Microbes in Human Welfare) is directly relevant to Microbiology degree subjects',
        },
        {
          step: 3, title: 'B.Sc Microbiology — Admission', icon: '📝',
          duration: 'May–July', type: 'exam',
          details: [
            'CUET UG → DU (B.Sc Microbiology), BHU (B.Sc Microbiology Hons), Jamia',
            'JNUEE → JNU B.Sc Life Sciences (then specialize in Microbiology for M.Sc)',
            'State university merit-based admissions — Pune University, Osmania, Mysore',
            'Amity, Christ University, Symbiosis, UPES — private colleges with good labs',
            'Duration: 3 years; some colleges offer 4-year B.Sc Hons',
          ],
          tip: 'Pune University B.Sc Microbiology (under SPPU) has one of the best industry connect in pharma-heavy Pune-Nasik corridor',
        },
        {
          step: 4, title: 'B.Sc Microbiology — 3 Years', icon: '🎓',
          duration: '3 years', type: 'education',
          details: [
            'Bacteriology, Virology, Mycology, Parasitology, Immunology',
            'Medical Microbiology, Food and Dairy Microbiology, Industrial Microbiology',
            'Environmental Microbiology, Agricultural Microbiology, Molecular Biology',
            'Lab skills: Culture techniques, Gram staining, Antibiotic sensitivity test (AST), PCR, ELISA',
            'Project work and dissertation in final year — choose pharma/food/clinical area',
          ],
          tip: 'Culture techniques, Gram staining, and AST are tested in pharma QC interviews — master these in practicals',
        },
        {
          step: 5, title: 'Pharma Industry — QA/QC & R&D', icon: '💊',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'Microbiology QC: Sterility testing, bioburden testing, water testing in pharma plants — largest hiring area',
            'QA (Quality Assurance): SOP writing, GMP compliance, CAPA preparation — ₹3.5L–₹12L',
            'R&D Microbiology: Vaccine development, antibiotic research, fermentation R&D',
            'Production (Biotech/Vaccine): Bioreactor operation, upstream/downstream processing',
            'All USFDA-approved pharma plants in India require microbiologists — 500+ FDA-approved plants',
            'Top hiring belt: Pune, Hyderabad, Ahmedabad, Mumbai pharma clusters',
          ],
          tip: 'USFDA compliance microbiologist in pharma industry earns ₹5L–₹15L — certification in GMP adds ₹2–3L to salary',
        },
        {
          step: 6, title: 'Clinical & Diagnostic Microbiology', icon: '🔬',
          duration: 'Ongoing', type: 'milestone',
          details: [
            'Hospital laboratory microbiologist — blood culture, urine culture, respiratory culture, AST reports',
            'SRL Diagnostics, Metropolis, Dr. Lal PathLabs, Thyrocare — diagnostic chain labs',
            'NABL-accredited labs: all hospital central labs — culture and sensitivity reports',
            'Infection Control Practitioner (ICP) — hospital infection control team (growing post-COVID)',
            'Molecular diagnostics: RT-PCR, NGS (Next Generation Sequencing) — premium skill for labs',
            'Blood bank technician / transfusion medicine — hospital blood bank microbiology',
          ],
          tip: 'NGS (Next Generation Sequencing) skill adds ₹3L–₹8L to salary — learn bioinformatics basics alongside M.Sc',
        },
        {
          step: 7, title: 'Food Safety & FSSAI', icon: '🍽️',
          duration: 'Ongoing', type: 'training',
          details: [
            'FSSAI (Food Safety and Standards Authority of India) — Food Safety Officer (central + state)',
            'Food testing laboratories: NABL-accredited labs testing for E. coli, Salmonella, Listeria',
            'Food companies: Nestle, Amul, ITC, Parle, Britannia, Haldiram — QA microbiologist',
            'Beverage & brewery industry: United Breweries, ABInBev, Diageo — fermentation microbiologist',
            'Dairy industry: Amul, Mother Dairy, Kwality — dairy QC microbiologist',
            'Export houses: Shrimp/poultry/spice exporters need HACCP-certified microbiologists',
          ],
          tip: 'FSSAI Food Safety Officer is a central/state govt post — excellent pay + stability; exam is manageable',
        },
        {
          step: 8, title: 'Research — CSIR, ICMR, NCDC, NIV', icon: '🧪',
          duration: 'Ongoing', type: 'education',
          details: [
            'CSIR UGC NET Life Sciences → JRF ₹31,000/month for PhD at CSIR-IMTECH, CSIR-IGIB',
            'ICMR JRF → Medical research at ICMR national institutes — tuberculosis, malaria, dengue research',
            'NIV Pune (National Institute of Virology) — viral outbreak research, zoonotic disease surveillance',
            'NCDC Delhi (National Centre for Disease Control) — epidemiology, outbreak investigation',
            'NIMR (National Institute of Malaria Research) — vector-borne disease research',
            'IISc / IIT / TIFR PhD — cutting-edge microbial ecology, synthetic biology, metagenomics',
          ],
          tip: 'NIV Pune is India\'s premier virology institute — being associated with it is exceptional for a research career',
        },
        {
          step: 9, title: 'M.Sc, Teaching, International & Growth', icon: '🚀',
          duration: 'Ongoing', type: 'growth',
          details: [
            'IIT JAM XL (Life Sciences) → M.Sc Microbiology/Biochemistry at IITs — career-transforming',
            'JNUEE PG → JNU M.Sc Life Sciences (strong research culture)',
            'CUET PG → BHU, Hyderabad University, DU M.Sc Microbiology',
            'UGC NET Life Sciences → Assistant Professor at college (₹57,700/month)',
            'MS abroad: USA (NIH-funded), Germany (DAAD), UK — PhD stipend $25K–$40K/year',
            'Environmental microbiology: Bioremediation startups, wastewater treatment, biogas plants',
            'Entrepreneurship: Diagnostic kit manufacturing, probiotics brand, microbial testing lab setup',
          ],
          tip: 'IIT JAM XL (Life Sciences) → IIT M.Sc → ₹8L–₹18L pharma placement — the most underused path in microbiology',
        },
      ],
      entranceExams: [
        { name: 'CUET UG', month: 'May', desc: 'DU, BHU, JMI B.Sc Microbiology admission' },
        { name: 'JNUEE', month: 'May', desc: 'JNU B.Sc Life Sciences — then M.Sc Microbiology' },
        { name: 'IIT JAM XL', month: 'February', desc: 'Life Sciences paper → M.Sc at IITs — career-transforming' },
        { name: 'CSIR UGC NET LS', month: 'Jun & Dec', desc: 'JRF ₹31K/month + PhD at CSIR labs' },
        { name: 'ICMR JRF', month: 'July', desc: 'Medical research JRF at ICMR national institutes' },
        { name: 'FSSAI Food Safety Officer', month: 'Varies', desc: 'Central/state govt food safety officer — for food microbiology path' },
        { name: 'UGC NET Life Sciences', month: 'Jun & Dec', desc: 'College/university lecturership eligibility' },
        { name: 'DBT JRF', month: 'September', desc: 'Dept of Biotechnology fellowship for microbiology research' },
      ],
      topColleges: [
        'Delhi University (B.Sc Microbiology)', 'BHU Varanasi',
        'Pune University (SPPU) — pharma hub advantage',
        'Hyderabad University', 'Osmania University',
        'Jamia Hamdard Delhi', 'Christ University Bangalore',
        'Amity University', 'Bangalore University',
        'IIT (via JAM XL for M.Sc)',
      ],
      careerGrowth: [
        { level: 'Entry (0–2 yrs)', role: 'QC Microbiologist / Lab Technician / Food Safety Analyst', salary: '₹3L – ₹6L' },
        { level: 'Mid (3–6 yrs)', role: 'Senior Microbiologist / QA Executive / Clinical Lab Officer', salary: '₹6L – ₹15L' },
        { level: 'Research / M.Sc IIT', role: 'Research Scientist / CSIR Scientist / Assistant Professor', salary: '₹57,700/month – ₹1.2L/month' },
        { level: 'International / Senior', role: 'Microbiology Scientist abroad / R&D Head', salary: '$55K–$110K/year | ₹20L–₹40L India senior' },
      ],
    },
  ],
};
